import { Z as Xi, h as Br } from "./index2.js";
import { p as j, b as ne, c as Ae, g as Gt, a as Zi } from "./jsx-runtime.js";
import { u as Gr, j as ue } from "./util.js";
function Ji(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function Qi(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var ea = /* @__PURE__ */ function() {
  function e(t) {
    var n = this;
    this._insertTag = function(i) {
      var o;
      n.tags.length === 0 ? n.insertionPoint ? o = n.insertionPoint.nextSibling : n.prepend ? o = n.container.firstChild : o = n.before : o = n.tags[n.tags.length - 1].nextSibling, n.container.insertBefore(i, o), n.tags.push(i);
    }, this.isSpeedy = t.speedy === void 0 ? j.env.NODE_ENV === "production" : t.speedy, this.tags = [], this.ctr = 0, this.nonce = t.nonce, this.key = t.key, this.container = t.container, this.prepend = t.prepend, this.insertionPoint = t.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(n) {
    n.forEach(this._insertTag);
  }, r.insert = function(n) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(Qi(this));
    var i = this.tags[this.tags.length - 1];
    if (j.env.NODE_ENV !== "production") {
      var o = n.charCodeAt(0) === 64 && n.charCodeAt(1) === 105;
      o && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + n + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !o;
    }
    if (this.isSpeedy) {
      var f = Ji(i);
      try {
        f.insertRule(n, f.cssRules.length);
      } catch (u) {
        j.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(n) && console.error('There was a problem inserting the following rule: "' + n + '"', u);
      }
    } else
      i.appendChild(document.createTextNode(n));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(n) {
      return n.parentNode && n.parentNode.removeChild(n);
    }), this.tags = [], this.ctr = 0, j.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), le = "-ms-", qr = "-moz-", V = "-webkit-", Vt = "comm", Yt = "rule", Kt = "decl", ra = "@import", Qn = "@keyframes", ta = "@layer", na = Math.abs, Vr = String.fromCharCode, ia = Object.assign;
function aa(e, r) {
  return se(e, 0) ^ 45 ? (((r << 2 ^ se(e, 0)) << 2 ^ se(e, 1)) << 2 ^ se(e, 2)) << 2 ^ se(e, 3) : 0;
}
function ei(e) {
  return e.trim();
}
function oa(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function Y(e, r, t) {
  return e.replace(r, t);
}
function Dt(e, r) {
  return e.indexOf(r);
}
function se(e, r) {
  return e.charCodeAt(r) | 0;
}
function _r(e, r, t) {
  return e.slice(r, t);
}
function Ce(e) {
  return e.length;
}
function Xt(e) {
  return e.length;
}
function Dr(e, r) {
  return r.push(e), e;
}
function fa(e, r) {
  return e.map(r).join("");
}
var Yr = 1, fr = 1, ri = 0, pe = 0, ie = 0, hr = "";
function Kr(e, r, t, n, i, o, f) {
  return { value: e, root: r, parent: t, type: n, props: i, children: o, line: Yr, column: fr, length: f, return: "" };
}
function mr(e, r) {
  return ia(Kr("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function sa() {
  return ie;
}
function ua() {
  return ie = pe > 0 ? se(hr, --pe) : 0, fr--, ie === 10 && (fr = 1, Yr--), ie;
}
function be() {
  return ie = pe < ri ? se(hr, pe++) : 0, fr++, ie === 10 && (fr = 1, Yr++), ie;
}
function Oe() {
  return se(hr, pe);
}
function Nr() {
  return pe;
}
function Cr(e, r) {
  return _r(hr, e, r);
}
function Sr(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function ti(e) {
  return Yr = fr = 1, ri = Ce(hr = e), pe = 0, [];
}
function ni(e) {
  return hr = "", e;
}
function Fr(e) {
  return ei(Cr(pe - 1, Ot(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function la(e) {
  for (; (ie = Oe()) && ie < 33; )
    be();
  return Sr(e) > 2 || Sr(ie) > 3 ? "" : " ";
}
function da(e, r) {
  for (; --r && be() && !(ie < 48 || ie > 102 || ie > 57 && ie < 65 || ie > 70 && ie < 97); )
    ;
  return Cr(e, Nr() + (r < 6 && Oe() == 32 && be() == 32));
}
function Ot(e) {
  for (; be(); )
    switch (ie) {
      case e:
        return pe;
      case 34:
      case 39:
        e !== 34 && e !== 39 && Ot(ie);
        break;
      case 40:
        e === 41 && Ot(e);
        break;
      case 92:
        be();
        break;
    }
  return pe;
}
function ca(e, r) {
  for (; be() && e + ie !== 47 + 10; )
    if (e + ie === 42 + 42 && Oe() === 47)
      break;
  return "/*" + Cr(r, pe - 1) + "*" + Vr(e === 47 ? e : be());
}
function ha(e) {
  for (; !Sr(Oe()); )
    be();
  return Cr(e, pe);
}
function pa(e) {
  return ni(jr("", null, null, null, [""], e = ti(e), 0, [0], e));
}
function jr(e, r, t, n, i, o, f, u, c) {
  for (var g = 0, y = 0, p = f, R = 0, N = 0, D = 0, x = 1, A = 1, b = 1, m = 0, O = "", _ = i, w = o, C = n, F = O; A; )
    switch (D = m, m = be()) {
      case 40:
        if (D != 108 && se(F, p - 1) == 58) {
          Dt(F += Y(Fr(m), "&", "&\f"), "&\f") != -1 && (b = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        F += Fr(m);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        F += la(D);
        break;
      case 92:
        F += da(Nr() - 1, 7);
        continue;
      case 47:
        switch (Oe()) {
          case 42:
          case 47:
            Dr(ga(ca(be(), Nr()), r, t), c);
            break;
          default:
            F += "/";
        }
        break;
      case 123 * x:
        u[g++] = Ce(F) * b;
      case 125 * x:
      case 59:
      case 0:
        switch (m) {
          case 0:
          case 125:
            A = 0;
          case 59 + y:
            b == -1 && (F = Y(F, /\f/g, "")), N > 0 && Ce(F) - p && Dr(N > 32 ? ln(F + ";", n, t, p - 1) : ln(Y(F, " ", "") + ";", n, t, p - 2), c);
            break;
          case 59:
            F += ";";
          default:
            if (Dr(C = un(F, r, t, g, y, i, u, O, _ = [], w = [], p), o), m === 123)
              if (y === 0)
                jr(F, r, C, C, _, o, p, u, w);
              else
                switch (R === 99 && se(F, 3) === 110 ? 100 : R) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    jr(e, C, C, n && Dr(un(e, C, C, 0, 0, i, u, O, i, _ = [], p), w), i, w, p, u, n ? _ : w);
                    break;
                  default:
                    jr(F, C, C, C, [""], w, 0, u, w);
                }
        }
        g = y = N = 0, x = b = 1, O = F = "", p = f;
        break;
      case 58:
        p = 1 + Ce(F), N = D;
      default:
        if (x < 1) {
          if (m == 123)
            --x;
          else if (m == 125 && x++ == 0 && ua() == 125)
            continue;
        }
        switch (F += Vr(m), m * x) {
          case 38:
            b = y > 0 ? 1 : (F += "\f", -1);
            break;
          case 44:
            u[g++] = (Ce(F) - 1) * b, b = 1;
            break;
          case 64:
            Oe() === 45 && (F += Fr(be())), R = Oe(), y = p = Ce(O = F += ha(Nr())), m++;
            break;
          case 45:
            D === 45 && Ce(F) == 2 && (x = 0);
        }
    }
  return o;
}
function un(e, r, t, n, i, o, f, u, c, g, y) {
  for (var p = i - 1, R = i === 0 ? o : [""], N = Xt(R), D = 0, x = 0, A = 0; D < n; ++D)
    for (var b = 0, m = _r(e, p + 1, p = na(x = f[D])), O = e; b < N; ++b)
      (O = ei(x > 0 ? R[b] + " " + m : Y(m, /&\f/g, R[b]))) && (c[A++] = O);
  return Kr(e, r, t, i === 0 ? Yt : u, c, g, y);
}
function ga(e, r, t) {
  return Kr(e, r, t, Vt, Vr(sa()), _r(e, 2, -2), 0);
}
function ln(e, r, t, n) {
  return Kr(e, r, t, Kt, _r(e, 0, n), _r(e, n + 1, -1), n);
}
function ir(e, r) {
  for (var t = "", n = Xt(e), i = 0; i < n; i++)
    t += r(e[i], i, e, r) || "";
  return t;
}
function ba(e, r, t, n) {
  switch (e.type) {
    case ta:
      if (e.children.length)
        break;
    case ra:
    case Kt:
      return e.return = e.return || e.value;
    case Vt:
      return "";
    case Qn:
      return e.return = e.value + "{" + ir(e.children, n) + "}";
    case Yt:
      e.value = e.props.join(",");
  }
  return Ce(t = ir(e.children, n)) ? e.return = e.value + "{" + t + "}" : "";
}
function va(e) {
  var r = Xt(e);
  return function(t, n, i, o) {
    for (var f = "", u = 0; u < r; u++)
      f += e[u](t, n, i, o) || "";
    return f;
  };
}
function ya(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
function ma(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(t) {
    return r[t] === void 0 && (r[t] = e(t)), r[t];
  };
}
var wa = function(r, t, n) {
  for (var i = 0, o = 0; i = o, o = Oe(), i === 38 && o === 12 && (t[n] = 1), !Sr(o); )
    be();
  return Cr(r, pe);
}, _a = function(r, t) {
  var n = -1, i = 44;
  do
    switch (Sr(i)) {
      case 0:
        i === 38 && Oe() === 12 && (t[n] = 1), r[n] += wa(pe - 1, t, n);
        break;
      case 2:
        r[n] += Fr(i);
        break;
      case 4:
        if (i === 44) {
          r[++n] = Oe() === 58 ? "&\f" : "", t[n] = r[n].length;
          break;
        }
      default:
        r[n] += Vr(i);
    }
  while (i = be());
  return r;
}, Sa = function(r, t) {
  return ni(_a(ti(r), t));
}, dn = /* @__PURE__ */ new WeakMap(), Ea = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var t = r.value, n = r.parent, i = r.column === n.column && r.line === n.line; n.type !== "rule"; )
      if (n = n.parent, !n)
        return;
    if (!(r.props.length === 1 && t.charCodeAt(0) !== 58 && !dn.get(n)) && !i) {
      dn.set(r, !0);
      for (var o = [], f = Sa(t, o), u = n.props, c = 0, g = 0; c < f.length; c++)
        for (var y = 0; y < u.length; y++, g++)
          r.props[g] = o[c] ? f[c].replace(/&\f/g, u[y]) : u[y] + " " + f[c];
    }
  }
}, Ra = function(r) {
  if (r.type === "decl") {
    var t = r.value;
    // charcode for l
    t.charCodeAt(0) === 108 && // charcode for b
    t.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
}, xa = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", Ta = function(r) {
  return r.type === "comm" && r.children.indexOf(xa) > -1;
}, ka = function(r) {
  return function(t, n, i) {
    if (!(t.type !== "rule" || r.compat)) {
      var o = t.value.match(/(:first|:nth|:nth-last)-child/g);
      if (o) {
        for (var f = !!t.parent, u = f ? t.parent.children : (
          // global rule at the root level
          i
        ), c = u.length - 1; c >= 0; c--) {
          var g = u[c];
          if (g.line < t.line)
            break;
          if (g.column < t.column) {
            if (Ta(g))
              return;
            break;
          }
        }
        o.forEach(function(y) {
          console.error('The pseudo class "' + y + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + y.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, ii = function(r) {
  return r.type.charCodeAt(1) === 105 && r.type.charCodeAt(0) === 64;
}, Ma = function(r, t) {
  for (var n = r - 1; n >= 0; n--)
    if (!ii(t[n]))
      return !0;
  return !1;
}, cn = function(r) {
  r.type = "", r.value = "", r.return = "", r.children = "", r.props = "";
}, Ca = function(r, t, n) {
  ii(r) && (r.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), cn(r)) : Ma(t, n) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), cn(r)));
};
function ai(e, r) {
  switch (aa(e, r)) {
    case 5103:
      return V + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return V + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return V + e + qr + e + le + e + e;
    case 6828:
    case 4268:
      return V + e + le + e + e;
    case 6165:
      return V + e + le + "flex-" + e + e;
    case 5187:
      return V + e + Y(e, /(\w+).+(:[^]+)/, V + "box-$1$2" + le + "flex-$1$2") + e;
    case 5443:
      return V + e + le + "flex-item-" + Y(e, /flex-|-self/, "") + e;
    case 4675:
      return V + e + le + "flex-line-pack" + Y(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return V + e + le + Y(e, "shrink", "negative") + e;
    case 5292:
      return V + e + le + Y(e, "basis", "preferred-size") + e;
    case 6060:
      return V + "box-" + Y(e, "-grow", "") + V + e + le + Y(e, "grow", "positive") + e;
    case 4554:
      return V + Y(e, /([^-])(transform)/g, "$1" + V + "$2") + e;
    case 6187:
      return Y(Y(Y(e, /(zoom-|grab)/, V + "$1"), /(image-set)/, V + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return Y(e, /(image-set\([^]*)/, V + "$1$`$1");
    case 4968:
      return Y(Y(e, /(.+:)(flex-)?(.*)/, V + "box-pack:$3" + le + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + V + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Y(e, /(.+)-inline(.+)/, V + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Ce(e) - 1 - r > 6)
        switch (se(e, r + 1)) {
          case 109:
            if (se(e, r + 4) !== 45)
              break;
          case 102:
            return Y(e, /(.+:)(.+)-([^]+)/, "$1" + V + "$2-$3$1" + qr + (se(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~Dt(e, "stretch") ? ai(Y(e, "stretch", "fill-available"), r) + e : e;
        }
      break;
    case 4949:
      if (se(e, r + 1) !== 115)
        break;
    case 6444:
      switch (se(e, Ce(e) - 3 - (~Dt(e, "!important") && 10))) {
        case 107:
          return Y(e, ":", ":" + V) + e;
        case 101:
          return Y(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + V + (se(e, 14) === 45 ? "inline-" : "") + "box$3$1" + V + "$2$3$1" + le + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (se(e, r + 11)) {
        case 114:
          return V + e + le + Y(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return V + e + le + Y(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return V + e + le + Y(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return V + e + le + e + e;
  }
  return e;
}
var Da = function(r, t, n, i) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case Kt:
        r.return = ai(r.value, r.length);
        break;
      case Qn:
        return ir([mr(r, {
          value: Y(r.value, "@", "@" + V)
        })], i);
      case Yt:
        if (r.length)
          return fa(r.props, function(o) {
            switch (oa(o, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return ir([mr(r, {
                  props: [Y(o, /:(read-\w+)/, ":" + qr + "$1")]
                })], i);
              case "::placeholder":
                return ir([mr(r, {
                  props: [Y(o, /:(plac\w+)/, ":" + V + "input-$1")]
                }), mr(r, {
                  props: [Y(o, /:(plac\w+)/, ":" + qr + "$1")]
                }), mr(r, {
                  props: [Y(o, /:(plac\w+)/, le + "input-$1")]
                })], i);
            }
            return "";
          });
    }
}, Oa = [Da], Aa = function(r) {
  var t = r.key;
  if (j.env.NODE_ENV !== "production" && !t)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (t === "css") {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function(x) {
      var A = x.getAttribute("data-emotion");
      A.indexOf(" ") !== -1 && (document.head.appendChild(x), x.setAttribute("data-s", ""));
    });
  }
  var i = r.stylisPlugins || Oa;
  if (j.env.NODE_ENV !== "production" && /[^a-z-]/.test(t))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + t + '" was passed');
  var o = {}, f, u = [];
  f = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + t + ' "]'),
    function(x) {
      for (var A = x.getAttribute("data-emotion").split(" "), b = 1; b < A.length; b++)
        o[A[b]] = !0;
      u.push(x);
    }
  );
  var c, g = [Ea, Ra];
  j.env.NODE_ENV !== "production" && g.push(ka({
    get compat() {
      return D.compat;
    }
  }), Ca);
  {
    var y, p = [ba, j.env.NODE_ENV !== "production" ? function(x) {
      x.root || (x.return ? y.insert(x.return) : x.value && x.type !== Vt && y.insert(x.value + "{}"));
    } : ya(function(x) {
      y.insert(x);
    })], R = va(g.concat(i, p)), N = function(A) {
      return ir(pa(A), R);
    };
    c = function(A, b, m, O) {
      y = m, j.env.NODE_ENV !== "production" && b.map !== void 0 && (y = {
        insert: function(w) {
          m.insert(w + b.map);
        }
      }), N(A ? A + "{" + b.styles + "}" : b.styles), O && (D.inserted[b.name] = !0);
    };
  }
  var D = {
    key: t,
    sheet: new ea({
      key: t,
      container: f,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: o,
    registered: {},
    insert: c
  };
  return D.sheet.hydrate(u), D;
};
function La(e) {
  for (var r = 0, t, n = 0, i = e.length; i >= 4; ++n, i -= 4)
    t = e.charCodeAt(n) & 255 | (e.charCodeAt(++n) & 255) << 8 | (e.charCodeAt(++n) & 255) << 16 | (e.charCodeAt(++n) & 255) << 24, t = /* Math.imul(k, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), t ^= /* k >>> r: */
    t >>> 24, r = /* Math.imul(k, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (i) {
    case 3:
      r ^= (e.charCodeAt(n + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(n + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(n) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var Pa = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, hn = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, Na = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", Fa = /[A-Z]|^ms/g, oi = /_EMO_([^_]+?)_([^]*?)_EMO_/g, Zt = function(r) {
  return r.charCodeAt(1) === 45;
}, pn = function(r) {
  return r != null && typeof r != "boolean";
}, nt = /* @__PURE__ */ ma(function(e) {
  return Zt(e) ? e : e.replace(Fa, "-$&").toLowerCase();
}), Wr = function(r, t) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof t == "string")
        return t.replace(oi, function(n, i, o) {
          return Re = {
            name: i,
            styles: o,
            next: Re
          }, i;
        });
  }
  return Pa[r] !== 1 && !Zt(r) && typeof t == "number" && t !== 0 ? t + "px" : t;
};
if (j.env.NODE_ENV !== "production") {
  var ja = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, Ia = ["normal", "none", "initial", "inherit", "unset"], Ba = Wr, qa = /^-ms-/, Wa = /-(.)/g, gn = {};
  Wr = function(r, t) {
    if (r === "content" && (typeof t != "string" || Ia.indexOf(t) === -1 && !ja.test(t) && (t.charAt(0) !== t.charAt(t.length - 1) || t.charAt(0) !== '"' && t.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + t + "\"'`");
    var n = Ba(r, t);
    return n !== "" && !Zt(r) && r.indexOf("-") !== -1 && gn[r] === void 0 && (gn[r] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + r.replace(qa, "ms-").replace(Wa, function(i, o) {
      return o.toUpperCase();
    }) + "?")), n;
  };
}
var fi = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Er(e, r, t) {
  if (t == null)
    return "";
  if (t.__emotion_styles !== void 0) {
    if (j.env.NODE_ENV !== "production" && t.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(fi);
    return t;
  }
  switch (typeof t) {
    case "boolean":
      return "";
    case "object": {
      if (t.anim === 1)
        return Re = {
          name: t.name,
          styles: t.styles,
          next: Re
        }, t.name;
      if (t.styles !== void 0) {
        var n = t.next;
        if (n !== void 0)
          for (; n !== void 0; )
            Re = {
              name: n.name,
              styles: n.styles,
              next: Re
            }, n = n.next;
        var i = t.styles + ";";
        return j.env.NODE_ENV !== "production" && t.map !== void 0 && (i += t.map), i;
      }
      return Ha(e, r, t);
    }
    case "function": {
      if (e !== void 0) {
        var o = Re, f = t(e);
        return Re = o, Er(e, r, f);
      } else
        j.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (j.env.NODE_ENV !== "production") {
        var u = [], c = t.replace(oi, function(y, p, R) {
          var N = "animation" + u.length;
          return u.push("const " + N + " = keyframes`" + R.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + N + "}";
        });
        u.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(u, ["`" + c + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + c + "`"));
      }
      break;
  }
  if (r == null)
    return t;
  var g = r[t];
  return g !== void 0 ? g : t;
}
function Ha(e, r, t) {
  var n = "";
  if (Array.isArray(t))
    for (var i = 0; i < t.length; i++)
      n += Er(e, r, t[i]) + ";";
  else
    for (var o in t) {
      var f = t[o];
      if (typeof f != "object")
        r != null && r[f] !== void 0 ? n += o + "{" + r[f] + "}" : pn(f) && (n += nt(o) + ":" + Wr(o, f) + ";");
      else {
        if (o === "NO_COMPONENT_SELECTOR" && j.env.NODE_ENV !== "production")
          throw new Error(fi);
        if (Array.isArray(f) && typeof f[0] == "string" && (r == null || r[f[0]] === void 0))
          for (var u = 0; u < f.length; u++)
            pn(f[u]) && (n += nt(o) + ":" + Wr(o, f[u]) + ";");
        else {
          var c = Er(e, r, f);
          switch (o) {
            case "animation":
            case "animationName": {
              n += nt(o) + ":" + c + ";";
              break;
            }
            default:
              j.env.NODE_ENV !== "production" && o === "undefined" && console.error(Na), n += o + "{" + c + "}";
          }
        }
      }
    }
  return n;
}
var bn = /label:\s*([^\s;\n{]+)\s*(;|$)/g, si;
j.env.NODE_ENV !== "production" && (si = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var Re, it = function(r, t, n) {
  if (r.length === 1 && typeof r[0] == "object" && r[0] !== null && r[0].styles !== void 0)
    return r[0];
  var i = !0, o = "";
  Re = void 0;
  var f = r[0];
  f == null || f.raw === void 0 ? (i = !1, o += Er(n, t, f)) : (j.env.NODE_ENV !== "production" && f[0] === void 0 && console.error(hn), o += f[0]);
  for (var u = 1; u < r.length; u++)
    o += Er(n, t, r[u]), i && (j.env.NODE_ENV !== "production" && f[u] === void 0 && console.error(hn), o += f[u]);
  var c;
  j.env.NODE_ENV !== "production" && (o = o.replace(si, function(R) {
    return c = R, "";
  })), bn.lastIndex = 0;
  for (var g = "", y; (y = bn.exec(o)) !== null; )
    g += "-" + // $FlowFixMe we know it's not null
    y[1];
  var p = La(o) + g;
  return j.env.NODE_ENV !== "production" ? {
    name: p,
    styles: o,
    map: c,
    next: Re,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: p,
    styles: o,
    next: Re
  };
}, $a = !0;
function ui(e, r, t) {
  var n = "";
  return t.split(" ").forEach(function(i) {
    e[i] !== void 0 ? r.push(e[i] + ";") : n += i + " ";
  }), n;
}
var Ua = function(r, t, n) {
  var i = r.key + "-" + t.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (n === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  $a === !1) && r.registered[i] === void 0 && (r.registered[i] = t.styles);
}, za = function(r, t, n) {
  Ua(r, t, n);
  var i = r.key + "-" + t.name;
  if (r.inserted[t.name] === void 0) {
    var o = t;
    do
      r.insert(t === o ? "." + i : "", o, r.sheet, !0), o = o.next;
    while (o !== void 0);
  }
};
function vn(e, r) {
  if (e.inserted[r.name] === void 0)
    return e.insert("", r, e.sheet, !0);
}
function yn(e, r, t) {
  var n = [], i = ui(e, n, t);
  return n.length < 2 ? t : i + r(n);
}
var Ga = function(r) {
  var t = Aa(r);
  t.sheet.speedy = function(u) {
    if (j.env.NODE_ENV !== "production" && this.ctr !== 0)
      throw new Error("speedy must be changed before any rules are inserted");
    this.isSpeedy = u;
  }, t.compat = !0;
  var n = function() {
    for (var c = arguments.length, g = new Array(c), y = 0; y < c; y++)
      g[y] = arguments[y];
    var p = it(g, t.registered, void 0);
    return za(t, p, !1), t.key + "-" + p.name;
  }, i = function() {
    for (var c = arguments.length, g = new Array(c), y = 0; y < c; y++)
      g[y] = arguments[y];
    var p = it(g, t.registered), R = "animation-" + p.name;
    return vn(t, {
      name: p.name,
      styles: "@keyframes " + R + "{" + p.styles + "}"
    }), R;
  }, o = function() {
    for (var c = arguments.length, g = new Array(c), y = 0; y < c; y++)
      g[y] = arguments[y];
    var p = it(g, t.registered);
    vn(t, p);
  }, f = function() {
    for (var c = arguments.length, g = new Array(c), y = 0; y < c; y++)
      g[y] = arguments[y];
    return yn(t.registered, n, Va(g));
  };
  return {
    css: n,
    cx: f,
    injectGlobal: o,
    keyframes: i,
    hydrate: function(c) {
      c.forEach(function(g) {
        t.inserted[g] = !0;
      });
    },
    flush: function() {
      t.registered = {}, t.inserted = {}, t.sheet.flush();
    },
    // $FlowFixMe
    sheet: t.sheet,
    cache: t,
    getRegisteredStyles: ui.bind(null, t.registered),
    merge: yn.bind(null, t.registered, n)
  };
}, Va = function e(r) {
  for (var t = "", n = 0; n < r.length; n++) {
    var i = r[n];
    if (i != null) {
      var o = void 0;
      switch (typeof i) {
        case "boolean":
          break;
        case "object": {
          if (Array.isArray(i))
            o = e(i);
          else {
            o = "";
            for (var f in i)
              i[f] && f && (o && (o += " "), o += f);
          }
          break;
        }
        default:
          o = i;
      }
      o && (t && (t += " "), t += o);
    }
  }
  return t;
}, li = { exports: {} }, Jt = { exports: {} }, ar = typeof Reflect == "object" ? Reflect : null, mn = ar && typeof ar.apply == "function" ? ar.apply : function(r, t, n) {
  return Function.prototype.apply.call(r, t, n);
}, Ir;
ar && typeof ar.ownKeys == "function" ? Ir = ar.ownKeys : Object.getOwnPropertySymbols ? Ir = function(r) {
  return Object.getOwnPropertyNames(r).concat(Object.getOwnPropertySymbols(r));
} : Ir = function(r) {
  return Object.getOwnPropertyNames(r);
};
function Ya(e) {
  console && console.warn && console.warn(e);
}
var di = Number.isNaN || function(r) {
  return r !== r;
};
function Z() {
  Z.init.call(this);
}
Jt.exports = Z;
Jt.exports.once = Ja;
Z.EventEmitter = Z;
Z.prototype._events = void 0;
Z.prototype._eventsCount = 0;
Z.prototype._maxListeners = void 0;
var wn = 10;
function Xr(e) {
  if (typeof e != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
}
Object.defineProperty(Z, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return wn;
  },
  set: function(e) {
    if (typeof e != "number" || e < 0 || di(e))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
    wn = e;
  }
});
Z.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
Z.prototype.setMaxListeners = function(r) {
  if (typeof r != "number" || r < 0 || di(r))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + r + ".");
  return this._maxListeners = r, this;
};
function ci(e) {
  return e._maxListeners === void 0 ? Z.defaultMaxListeners : e._maxListeners;
}
Z.prototype.getMaxListeners = function() {
  return ci(this);
};
Z.prototype.emit = function(r) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t.push(arguments[n]);
  var i = r === "error", o = this._events;
  if (o !== void 0)
    i = i && o.error === void 0;
  else if (!i)
    return !1;
  if (i) {
    var f;
    if (t.length > 0 && (f = t[0]), f instanceof Error)
      throw f;
    var u = new Error("Unhandled error." + (f ? " (" + f.message + ")" : ""));
    throw u.context = f, u;
  }
  var c = o[r];
  if (c === void 0)
    return !1;
  if (typeof c == "function")
    mn(c, this, t);
  else
    for (var g = c.length, y = vi(c, g), n = 0; n < g; ++n)
      mn(y[n], this, t);
  return !0;
};
function hi(e, r, t, n) {
  var i, o, f;
  if (Xr(t), o = e._events, o === void 0 ? (o = e._events = /* @__PURE__ */ Object.create(null), e._eventsCount = 0) : (o.newListener !== void 0 && (e.emit(
    "newListener",
    r,
    t.listener ? t.listener : t
  ), o = e._events), f = o[r]), f === void 0)
    f = o[r] = t, ++e._eventsCount;
  else if (typeof f == "function" ? f = o[r] = n ? [t, f] : [f, t] : n ? f.unshift(t) : f.push(t), i = ci(e), i > 0 && f.length > i && !f.warned) {
    f.warned = !0;
    var u = new Error("Possible EventEmitter memory leak detected. " + f.length + " " + String(r) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    u.name = "MaxListenersExceededWarning", u.emitter = e, u.type = r, u.count = f.length, Ya(u);
  }
  return e;
}
Z.prototype.addListener = function(r, t) {
  return hi(this, r, t, !1);
};
Z.prototype.on = Z.prototype.addListener;
Z.prototype.prependListener = function(r, t) {
  return hi(this, r, t, !0);
};
function Ka() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function pi(e, r, t) {
  var n = { fired: !1, wrapFn: void 0, target: e, type: r, listener: t }, i = Ka.bind(n);
  return i.listener = t, n.wrapFn = i, i;
}
Z.prototype.once = function(r, t) {
  return Xr(t), this.on(r, pi(this, r, t)), this;
};
Z.prototype.prependOnceListener = function(r, t) {
  return Xr(t), this.prependListener(r, pi(this, r, t)), this;
};
Z.prototype.removeListener = function(r, t) {
  var n, i, o, f, u;
  if (Xr(t), i = this._events, i === void 0)
    return this;
  if (n = i[r], n === void 0)
    return this;
  if (n === t || n.listener === t)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete i[r], i.removeListener && this.emit("removeListener", r, n.listener || t));
  else if (typeof n != "function") {
    for (o = -1, f = n.length - 1; f >= 0; f--)
      if (n[f] === t || n[f].listener === t) {
        u = n[f].listener, o = f;
        break;
      }
    if (o < 0)
      return this;
    o === 0 ? n.shift() : Xa(n, o), n.length === 1 && (i[r] = n[0]), i.removeListener !== void 0 && this.emit("removeListener", r, u || t);
  }
  return this;
};
Z.prototype.off = Z.prototype.removeListener;
Z.prototype.removeAllListeners = function(r) {
  var t, n, i;
  if (n = this._events, n === void 0)
    return this;
  if (n.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : n[r] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete n[r]), this;
  if (arguments.length === 0) {
    var o = Object.keys(n), f;
    for (i = 0; i < o.length; ++i)
      f = o[i], f !== "removeListener" && this.removeAllListeners(f);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (t = n[r], typeof t == "function")
    this.removeListener(r, t);
  else if (t !== void 0)
    for (i = t.length - 1; i >= 0; i--)
      this.removeListener(r, t[i]);
  return this;
};
function gi(e, r, t) {
  var n = e._events;
  if (n === void 0)
    return [];
  var i = n[r];
  return i === void 0 ? [] : typeof i == "function" ? t ? [i.listener || i] : [i] : t ? Za(i) : vi(i, i.length);
}
Z.prototype.listeners = function(r) {
  return gi(this, r, !0);
};
Z.prototype.rawListeners = function(r) {
  return gi(this, r, !1);
};
Z.listenerCount = function(e, r) {
  return typeof e.listenerCount == "function" ? e.listenerCount(r) : bi.call(e, r);
};
Z.prototype.listenerCount = bi;
function bi(e) {
  var r = this._events;
  if (r !== void 0) {
    var t = r[e];
    if (typeof t == "function")
      return 1;
    if (t !== void 0)
      return t.length;
  }
  return 0;
}
Z.prototype.eventNames = function() {
  return this._eventsCount > 0 ? Ir(this._events) : [];
};
function vi(e, r) {
  for (var t = new Array(r), n = 0; n < r; ++n)
    t[n] = e[n];
  return t;
}
function Xa(e, r) {
  for (; r + 1 < e.length; r++)
    e[r] = e[r + 1];
  e.pop();
}
function Za(e) {
  for (var r = new Array(e.length), t = 0; t < r.length; ++t)
    r[t] = e[t].listener || e[t];
  return r;
}
function Ja(e, r) {
  return new Promise(function(t, n) {
    function i(f) {
      e.removeListener(r, o), n(f);
    }
    function o() {
      typeof e.removeListener == "function" && e.removeListener("error", i), t([].slice.call(arguments));
    }
    yi(e, r, o, { once: !0 }), r !== "error" && Qa(e, i, { once: !0 });
  });
}
function Qa(e, r, t) {
  typeof e.on == "function" && yi(e, "error", r, t);
}
function yi(e, r, t, n) {
  if (typeof e.on == "function")
    n.once ? e.once(r, t) : e.on(r, t);
  else if (typeof e.addEventListener == "function")
    e.addEventListener(r, function i(o) {
      n.once && e.removeEventListener(r, i), t(o);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof e);
}
var pr = Jt.exports, at, _n;
function mi() {
  return _n || (_n = 1, at = pr.EventEmitter), at;
}
var ot, Sn;
function eo() {
  if (Sn)
    return ot;
  Sn = 1;
  function e(D, x) {
    var A = Object.keys(D);
    if (Object.getOwnPropertySymbols) {
      var b = Object.getOwnPropertySymbols(D);
      x && (b = b.filter(function(m) {
        return Object.getOwnPropertyDescriptor(D, m).enumerable;
      })), A.push.apply(A, b);
    }
    return A;
  }
  function r(D) {
    for (var x = 1; x < arguments.length; x++) {
      var A = arguments[x] != null ? arguments[x] : {};
      x % 2 ? e(Object(A), !0).forEach(function(b) {
        t(D, b, A[b]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(D, Object.getOwnPropertyDescriptors(A)) : e(Object(A)).forEach(function(b) {
        Object.defineProperty(D, b, Object.getOwnPropertyDescriptor(A, b));
      });
    }
    return D;
  }
  function t(D, x, A) {
    return x = f(x), x in D ? Object.defineProperty(D, x, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : D[x] = A, D;
  }
  function n(D, x) {
    if (!(D instanceof x))
      throw new TypeError("Cannot call a class as a function");
  }
  function i(D, x) {
    for (var A = 0; A < x.length; A++) {
      var b = x[A];
      b.enumerable = b.enumerable || !1, b.configurable = !0, "value" in b && (b.writable = !0), Object.defineProperty(D, f(b.key), b);
    }
  }
  function o(D, x, A) {
    return x && i(D.prototype, x), A && i(D, A), Object.defineProperty(D, "prototype", { writable: !1 }), D;
  }
  function f(D) {
    var x = u(D, "string");
    return typeof x == "symbol" ? x : String(x);
  }
  function u(D, x) {
    if (typeof D != "object" || D === null)
      return D;
    var A = D[Symbol.toPrimitive];
    if (A !== void 0) {
      var b = A.call(D, x || "default");
      if (typeof b != "object")
        return b;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (x === "string" ? String : Number)(D);
  }
  var c = ne, g = c.Buffer, y = Gr, p = y.inspect, R = p && p.custom || "inspect";
  function N(D, x, A) {
    g.prototype.copy.call(D, x, A);
  }
  return ot = /* @__PURE__ */ function() {
    function D() {
      n(this, D), this.head = null, this.tail = null, this.length = 0;
    }
    return o(D, [{
      key: "push",
      value: function(A) {
        var b = {
          data: A,
          next: null
        };
        this.length > 0 ? this.tail.next = b : this.head = b, this.tail = b, ++this.length;
      }
    }, {
      key: "unshift",
      value: function(A) {
        var b = {
          data: A,
          next: this.head
        };
        this.length === 0 && (this.tail = b), this.head = b, ++this.length;
      }
    }, {
      key: "shift",
      value: function() {
        if (this.length !== 0) {
          var A = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, A;
        }
      }
    }, {
      key: "clear",
      value: function() {
        this.head = this.tail = null, this.length = 0;
      }
    }, {
      key: "join",
      value: function(A) {
        if (this.length === 0)
          return "";
        for (var b = this.head, m = "" + b.data; b = b.next; )
          m += A + b.data;
        return m;
      }
    }, {
      key: "concat",
      value: function(A) {
        if (this.length === 0)
          return g.alloc(0);
        for (var b = g.allocUnsafe(A >>> 0), m = this.head, O = 0; m; )
          N(m.data, b, O), O += m.data.length, m = m.next;
        return b;
      }
      // Consumes a specified amount of bytes or characters from the buffered data.
    }, {
      key: "consume",
      value: function(A, b) {
        var m;
        return A < this.head.data.length ? (m = this.head.data.slice(0, A), this.head.data = this.head.data.slice(A)) : A === this.head.data.length ? m = this.shift() : m = b ? this._getString(A) : this._getBuffer(A), m;
      }
    }, {
      key: "first",
      value: function() {
        return this.head.data;
      }
      // Consumes a specified amount of characters from the buffered data.
    }, {
      key: "_getString",
      value: function(A) {
        var b = this.head, m = 1, O = b.data;
        for (A -= O.length; b = b.next; ) {
          var _ = b.data, w = A > _.length ? _.length : A;
          if (w === _.length ? O += _ : O += _.slice(0, A), A -= w, A === 0) {
            w === _.length ? (++m, b.next ? this.head = b.next : this.head = this.tail = null) : (this.head = b, b.data = _.slice(w));
            break;
          }
          ++m;
        }
        return this.length -= m, O;
      }
      // Consumes a specified amount of bytes from the buffered data.
    }, {
      key: "_getBuffer",
      value: function(A) {
        var b = g.allocUnsafe(A), m = this.head, O = 1;
        for (m.data.copy(b), A -= m.data.length; m = m.next; ) {
          var _ = m.data, w = A > _.length ? _.length : A;
          if (_.copy(b, b.length - A, 0, w), A -= w, A === 0) {
            w === _.length ? (++O, m.next ? this.head = m.next : this.head = this.tail = null) : (this.head = m, m.data = _.slice(w));
            break;
          }
          ++O;
        }
        return this.length -= O, b;
      }
      // Make sure the linked list only shows the minimal necessary information.
    }, {
      key: R,
      value: function(A, b) {
        return p(this, r(r({}, b), {}, {
          // Only inspect one level.
          depth: 0,
          // It should not recurse.
          customInspect: !1
        }));
      }
    }]), D;
  }(), ot;
}
var ft, En;
function wi() {
  if (En)
    return ft;
  En = 1;
  function e(f, u) {
    var c = this, g = this._readableState && this._readableState.destroyed, y = this._writableState && this._writableState.destroyed;
    return g || y ? (u ? u(f) : f && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, j.nextTick(i, this, f)) : j.nextTick(i, this, f)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(f || null, function(p) {
      !u && p ? c._writableState ? c._writableState.errorEmitted ? j.nextTick(t, c) : (c._writableState.errorEmitted = !0, j.nextTick(r, c, p)) : j.nextTick(r, c, p) : u ? (j.nextTick(t, c), u(p)) : j.nextTick(t, c);
    }), this);
  }
  function r(f, u) {
    i(f, u), t(f);
  }
  function t(f) {
    f._writableState && !f._writableState.emitClose || f._readableState && !f._readableState.emitClose || f.emit("close");
  }
  function n() {
    this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
  }
  function i(f, u) {
    f.emit("error", u);
  }
  function o(f, u) {
    var c = f._readableState, g = f._writableState;
    c && c.autoDestroy || g && g.autoDestroy ? f.destroy(u) : f.emit("error", u);
  }
  return ft = {
    destroy: e,
    undestroy: n,
    errorOrDestroy: o
  }, ft;
}
var st = {}, Rn;
function gr() {
  if (Rn)
    return st;
  Rn = 1;
  function e(u, c) {
    u.prototype = Object.create(c.prototype), u.prototype.constructor = u, u.__proto__ = c;
  }
  var r = {};
  function t(u, c, g) {
    g || (g = Error);
    function y(R, N, D) {
      return typeof c == "string" ? c : c(R, N, D);
    }
    var p = /* @__PURE__ */ function(R) {
      e(N, R);
      function N(D, x, A) {
        return R.call(this, y(D, x, A)) || this;
      }
      return N;
    }(g);
    p.prototype.name = g.name, p.prototype.code = u, r[u] = p;
  }
  function n(u, c) {
    if (Array.isArray(u)) {
      var g = u.length;
      return u = u.map(function(y) {
        return String(y);
      }), g > 2 ? "one of ".concat(c, " ").concat(u.slice(0, g - 1).join(", "), ", or ") + u[g - 1] : g === 2 ? "one of ".concat(c, " ").concat(u[0], " or ").concat(u[1]) : "of ".concat(c, " ").concat(u[0]);
    } else
      return "of ".concat(c, " ").concat(String(u));
  }
  function i(u, c, g) {
    return u.substr(!g || g < 0 ? 0 : +g, c.length) === c;
  }
  function o(u, c, g) {
    return (g === void 0 || g > u.length) && (g = u.length), u.substring(g - c.length, g) === c;
  }
  function f(u, c, g) {
    return typeof g != "number" && (g = 0), g + c.length > u.length ? !1 : u.indexOf(c, g) !== -1;
  }
  return t("ERR_INVALID_OPT_VALUE", function(u, c) {
    return 'The value "' + c + '" is invalid for option "' + u + '"';
  }, TypeError), t("ERR_INVALID_ARG_TYPE", function(u, c, g) {
    var y;
    typeof c == "string" && i(c, "not ") ? (y = "must not be", c = c.replace(/^not /, "")) : y = "must be";
    var p;
    if (o(u, " argument"))
      p = "The ".concat(u, " ").concat(y, " ").concat(n(c, "type"));
    else {
      var R = f(u, ".") ? "property" : "argument";
      p = 'The "'.concat(u, '" ').concat(R, " ").concat(y, " ").concat(n(c, "type"));
    }
    return p += ". Received type ".concat(typeof g), p;
  }, TypeError), t("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), t("ERR_METHOD_NOT_IMPLEMENTED", function(u) {
    return "The " + u + " method is not implemented";
  }), t("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), t("ERR_STREAM_DESTROYED", function(u) {
    return "Cannot call " + u + " after a stream was destroyed";
  }), t("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), t("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), t("ERR_STREAM_WRITE_AFTER_END", "write after end"), t("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), t("ERR_UNKNOWN_ENCODING", function(u) {
    return "Unknown encoding: " + u;
  }, TypeError), t("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), st.codes = r, st;
}
var ut, xn;
function _i() {
  if (xn)
    return ut;
  xn = 1;
  var e = gr().codes.ERR_INVALID_OPT_VALUE;
  function r(n, i, o) {
    return n.highWaterMark != null ? n.highWaterMark : i ? n[o] : null;
  }
  function t(n, i, o, f) {
    var u = r(i, f, o);
    if (u != null) {
      if (!(isFinite(u) && Math.floor(u) === u) || u < 0) {
        var c = f ? o : "highWaterMark";
        throw new e(c, u);
      }
      return Math.floor(u);
    }
    return n.objectMode ? 16 : 16 * 1024;
  }
  return ut = {
    getHighWaterMark: t
  }, ut;
}
var lt, Tn;
function Si() {
  if (Tn)
    return lt;
  Tn = 1, lt = e;
  function e(t, n) {
    if (r("noDeprecation"))
      return t;
    var i = !1;
    function o() {
      if (!i) {
        if (r("throwDeprecation"))
          throw new Error(n);
        r("traceDeprecation") ? console.trace(n) : console.warn(n), i = !0;
      }
      return t.apply(this, arguments);
    }
    return o;
  }
  function r(t) {
    try {
      if (!Ae.localStorage)
        return !1;
    } catch {
      return !1;
    }
    var n = Ae.localStorage[t];
    return n == null ? !1 : String(n).toLowerCase() === "true";
  }
  return lt;
}
var dt, kn;
function Ei() {
  if (kn)
    return dt;
  kn = 1, dt = B;
  function e(S) {
    var a = this;
    this.next = null, this.entry = null, this.finish = function() {
      _e(a, S);
    };
  }
  var r;
  B.WritableState = C;
  var t = {
    deprecate: Si()
  }, n = mi(), i = ne.Buffer, o = (typeof Ae < "u" ? Ae : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function f(S) {
    return i.from(S);
  }
  function u(S) {
    return i.isBuffer(S) || S instanceof o;
  }
  var c = wi(), g = _i(), y = g.getHighWaterMark, p = gr().codes, R = p.ERR_INVALID_ARG_TYPE, N = p.ERR_METHOD_NOT_IMPLEMENTED, D = p.ERR_MULTIPLE_CALLBACK, x = p.ERR_STREAM_CANNOT_PIPE, A = p.ERR_STREAM_DESTROYED, b = p.ERR_STREAM_NULL_VALUES, m = p.ERR_STREAM_WRITE_AFTER_END, O = p.ERR_UNKNOWN_ENCODING, _ = c.errorOrDestroy;
  ue(B, n);
  function w() {
  }
  function C(S, a, s) {
    r = r || sr(), S = S || {}, typeof s != "boolean" && (s = a instanceof r), this.objectMode = !!S.objectMode, s && (this.objectMode = this.objectMode || !!S.writableObjectMode), this.highWaterMark = y(this, S, "writableHighWaterMark", s), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var T = S.decodeStrings === !1;
    this.decodeStrings = !T, this.defaultEncoding = S.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(L) {
      ze(a, L);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = S.emitClose !== !1, this.autoDestroy = !!S.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new e(this);
  }
  C.prototype.getBuffer = function() {
    for (var a = this.bufferedRequest, s = []; a; )
      s.push(a), a = a.next;
    return s;
  }, function() {
    try {
      Object.defineProperty(C.prototype, "buffer", {
        get: t.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var F;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (F = Function.prototype[Symbol.hasInstance], Object.defineProperty(B, Symbol.hasInstance, {
    value: function(a) {
      return F.call(this, a) ? !0 : this !== B ? !1 : a && a._writableState instanceof C;
    }
  })) : F = function(a) {
    return a instanceof this;
  };
  function B(S) {
    r = r || sr();
    var a = this instanceof r;
    if (!a && !F.call(B, this))
      return new B(S);
    this._writableState = new C(S, this, a), this.writable = !0, S && (typeof S.write == "function" && (this._write = S.write), typeof S.writev == "function" && (this._writev = S.writev), typeof S.destroy == "function" && (this._destroy = S.destroy), typeof S.final == "function" && (this._final = S.final)), n.call(this);
  }
  B.prototype.pipe = function() {
    _(this, new x());
  };
  function q(S, a) {
    var s = new m();
    _(S, s), j.nextTick(a, s);
  }
  function ae(S, a, s, T) {
    var L;
    return s === null ? L = new b() : typeof s != "string" && !a.objectMode && (L = new R("chunk", ["string", "Buffer"], s)), L ? (_(S, L), j.nextTick(T, L), !1) : !0;
  }
  B.prototype.write = function(S, a, s) {
    var T = this._writableState, L = !1, d = !T.objectMode && u(S);
    return d && !i.isBuffer(S) && (S = f(S)), typeof a == "function" && (s = a, a = null), d ? a = "buffer" : a || (a = T.defaultEncoding), typeof s != "function" && (s = w), T.ending ? q(this, s) : (d || ae(this, T, S, s)) && (T.pendingcb++, L = Ie(this, T, d, S, a, s)), L;
  }, B.prototype.cork = function() {
    this._writableState.corked++;
  }, B.prototype.uncork = function() {
    var S = this._writableState;
    S.corked && (S.corked--, !S.writing && !S.corked && !S.bufferProcessing && S.bufferedRequest && P(this, S));
  }, B.prototype.setDefaultEncoding = function(a) {
    if (typeof a == "string" && (a = a.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((a + "").toLowerCase()) > -1))
      throw new O(a);
    return this._writableState.defaultEncoding = a, this;
  }, Object.defineProperty(B.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  });
  function de(S, a, s) {
    return !S.objectMode && S.decodeStrings !== !1 && typeof a == "string" && (a = i.from(a, s)), a;
  }
  Object.defineProperty(B.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function Ie(S, a, s, T, L, d) {
    if (!s) {
      var l = de(a, T, L);
      T !== l && (s = !0, L = "buffer", T = l);
    }
    var M = a.objectMode ? 1 : T.length;
    a.length += M;
    var I = a.length < a.highWaterMark;
    if (I || (a.needDrain = !0), a.writing || a.corked) {
      var Q = a.lastBufferedRequest;
      a.lastBufferedRequest = {
        chunk: T,
        encoding: L,
        isBuf: s,
        callback: d,
        next: null
      }, Q ? Q.next = a.lastBufferedRequest : a.bufferedRequest = a.lastBufferedRequest, a.bufferedRequestCount += 1;
    } else
      me(S, a, !1, M, T, L, d);
    return I;
  }
  function me(S, a, s, T, L, d, l) {
    a.writelen = T, a.writecb = l, a.writing = !0, a.sync = !0, a.destroyed ? a.onwrite(new A("write")) : s ? S._writev(L, a.onwrite) : S._write(L, d, a.onwrite), a.sync = !1;
  }
  function we(S, a, s, T, L) {
    --a.pendingcb, s ? (j.nextTick(L, T), j.nextTick(oe, S, a), S._writableState.errorEmitted = !0, _(S, T)) : (L(T), S._writableState.errorEmitted = !0, _(S, T), oe(S, a));
  }
  function Be(S) {
    S.writing = !1, S.writecb = null, S.length -= S.writelen, S.writelen = 0;
  }
  function ze(S, a) {
    var s = S._writableState, T = s.sync, L = s.writecb;
    if (typeof L != "function")
      throw new D();
    if (Be(s), a)
      we(S, s, T, a, L);
    else {
      var d = H(s) || S.destroyed;
      !d && !s.corked && !s.bufferProcessing && s.bufferedRequest && P(S, s), T ? j.nextTick(E, S, s, d, L) : E(S, s, d, L);
    }
  }
  function E(S, a, s, T) {
    s || k(S, a), a.pendingcb--, T(), oe(S, a);
  }
  function k(S, a) {
    a.length === 0 && a.needDrain && (a.needDrain = !1, S.emit("drain"));
  }
  function P(S, a) {
    a.bufferProcessing = !0;
    var s = a.bufferedRequest;
    if (S._writev && s && s.next) {
      var T = a.bufferedRequestCount, L = new Array(T), d = a.corkedRequestsFree;
      d.entry = s;
      for (var l = 0, M = !0; s; )
        L[l] = s, s.isBuf || (M = !1), s = s.next, l += 1;
      L.allBuffers = M, me(S, a, !0, a.length, L, "", d.finish), a.pendingcb++, a.lastBufferedRequest = null, d.next ? (a.corkedRequestsFree = d.next, d.next = null) : a.corkedRequestsFree = new e(a), a.bufferedRequestCount = 0;
    } else {
      for (; s; ) {
        var I = s.chunk, Q = s.encoding, $ = s.callback, K = a.objectMode ? 1 : I.length;
        if (me(S, a, !1, K, I, Q, $), s = s.next, a.bufferedRequestCount--, a.writing)
          break;
      }
      s === null && (a.lastBufferedRequest = null);
    }
    a.bufferedRequest = s, a.bufferProcessing = !1;
  }
  B.prototype._write = function(S, a, s) {
    s(new N("_write()"));
  }, B.prototype._writev = null, B.prototype.end = function(S, a, s) {
    var T = this._writableState;
    return typeof S == "function" ? (s = S, S = null, a = null) : typeof a == "function" && (s = a, a = null), S != null && this.write(S, a), T.corked && (T.corked = 1, this.uncork()), T.ending || ce(this, T, s), this;
  }, Object.defineProperty(B.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function H(S) {
    return S.ending && S.length === 0 && S.bufferedRequest === null && !S.finished && !S.writing;
  }
  function U(S, a) {
    S._final(function(s) {
      a.pendingcb--, s && _(S, s), a.prefinished = !0, S.emit("prefinish"), oe(S, a);
    });
  }
  function z(S, a) {
    !a.prefinished && !a.finalCalled && (typeof S._final == "function" && !a.destroyed ? (a.pendingcb++, a.finalCalled = !0, j.nextTick(U, S, a)) : (a.prefinished = !0, S.emit("prefinish")));
  }
  function oe(S, a) {
    var s = H(a);
    if (s && (z(S, a), a.pendingcb === 0 && (a.finished = !0, S.emit("finish"), a.autoDestroy))) {
      var T = S._readableState;
      (!T || T.autoDestroy && T.endEmitted) && S.destroy();
    }
    return s;
  }
  function ce(S, a, s) {
    a.ending = !0, oe(S, a), s && (a.finished ? j.nextTick(s) : S.once("finish", s)), a.ended = !0, S.writable = !1;
  }
  function _e(S, a, s) {
    var T = S.entry;
    for (S.entry = null; T; ) {
      var L = T.callback;
      a.pendingcb--, L(s), T = T.next;
    }
    a.corkedRequestsFree.next = S;
  }
  return Object.defineProperty(B.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(a) {
      this._writableState && (this._writableState.destroyed = a);
    }
  }), B.prototype.destroy = c.destroy, B.prototype._undestroy = c.undestroy, B.prototype._destroy = function(S, a) {
    a(S);
  }, dt;
}
var ct, Mn;
function sr() {
  if (Mn)
    return ct;
  Mn = 1;
  var e = Object.keys || function(g) {
    var y = [];
    for (var p in g)
      y.push(p);
    return y;
  };
  ct = f;
  var r = Ri(), t = Ei();
  ue(f, r);
  for (var n = e(t.prototype), i = 0; i < n.length; i++) {
    var o = n[i];
    f.prototype[o] || (f.prototype[o] = t.prototype[o]);
  }
  function f(g) {
    if (!(this instanceof f))
      return new f(g);
    r.call(this, g), t.call(this, g), this.allowHalfOpen = !0, g && (g.readable === !1 && (this.readable = !1), g.writable === !1 && (this.writable = !1), g.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", u)));
  }
  Object.defineProperty(f.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  }), Object.defineProperty(f.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  }), Object.defineProperty(f.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function u() {
    this._writableState.ended || j.nextTick(c, this);
  }
  function c(g) {
    g.end();
  }
  return Object.defineProperty(f.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(y) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = y, this._writableState.destroyed = y);
    }
  }), ct;
}
var ht = {}, Or = { exports: {} }, Cn;
function ro() {
  return Cn || (Cn = 1, function(e, r) {
    var t = ne, n = t.Buffer;
    function i(f, u) {
      for (var c in f)
        u[c] = f[c];
    }
    n.from && n.alloc && n.allocUnsafe && n.allocUnsafeSlow ? e.exports = t : (i(t, r), r.Buffer = o);
    function o(f, u, c) {
      return n(f, u, c);
    }
    i(n, o), o.from = function(f, u, c) {
      if (typeof f == "number")
        throw new TypeError("Argument must not be a number");
      return n(f, u, c);
    }, o.alloc = function(f, u, c) {
      if (typeof f != "number")
        throw new TypeError("Argument must be a number");
      var g = n(f);
      return u !== void 0 ? typeof c == "string" ? g.fill(u, c) : g.fill(u) : g.fill(0), g;
    }, o.allocUnsafe = function(f) {
      if (typeof f != "number")
        throw new TypeError("Argument must be a number");
      return n(f);
    }, o.allocUnsafeSlow = function(f) {
      if (typeof f != "number")
        throw new TypeError("Argument must be a number");
      return t.SlowBuffer(f);
    };
  }(Or, Or.exports)), Or.exports;
}
var Dn;
function ur() {
  if (Dn)
    return ht;
  Dn = 1;
  var e = ro().Buffer, r = e.isEncoding || function(b) {
    switch (b = "" + b, b && b.toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
      case "raw":
        return !0;
      default:
        return !1;
    }
  };
  function t(b) {
    if (!b)
      return "utf8";
    for (var m; ; )
      switch (b) {
        case "utf8":
        case "utf-8":
          return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return "utf16le";
        case "latin1":
        case "binary":
          return "latin1";
        case "base64":
        case "ascii":
        case "hex":
          return b;
        default:
          if (m)
            return;
          b = ("" + b).toLowerCase(), m = !0;
      }
  }
  function n(b) {
    var m = t(b);
    if (typeof m != "string" && (e.isEncoding === r || !r(b)))
      throw new Error("Unknown encoding: " + b);
    return m || b;
  }
  ht.StringDecoder = i;
  function i(b) {
    this.encoding = n(b);
    var m;
    switch (this.encoding) {
      case "utf16le":
        this.text = p, this.end = R, m = 4;
        break;
      case "utf8":
        this.fillLast = c, m = 4;
        break;
      case "base64":
        this.text = N, this.end = D, m = 3;
        break;
      default:
        this.write = x, this.end = A;
        return;
    }
    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = e.allocUnsafe(m);
  }
  i.prototype.write = function(b) {
    if (b.length === 0)
      return "";
    var m, O;
    if (this.lastNeed) {
      if (m = this.fillLast(b), m === void 0)
        return "";
      O = this.lastNeed, this.lastNeed = 0;
    } else
      O = 0;
    return O < b.length ? m ? m + this.text(b, O) : this.text(b, O) : m || "";
  }, i.prototype.end = y, i.prototype.text = g, i.prototype.fillLast = function(b) {
    if (this.lastNeed <= b.length)
      return b.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    b.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, b.length), this.lastNeed -= b.length;
  };
  function o(b) {
    return b <= 127 ? 0 : b >> 5 === 6 ? 2 : b >> 4 === 14 ? 3 : b >> 3 === 30 ? 4 : b >> 6 === 2 ? -1 : -2;
  }
  function f(b, m, O) {
    var _ = m.length - 1;
    if (_ < O)
      return 0;
    var w = o(m[_]);
    return w >= 0 ? (w > 0 && (b.lastNeed = w - 1), w) : --_ < O || w === -2 ? 0 : (w = o(m[_]), w >= 0 ? (w > 0 && (b.lastNeed = w - 2), w) : --_ < O || w === -2 ? 0 : (w = o(m[_]), w >= 0 ? (w > 0 && (w === 2 ? w = 0 : b.lastNeed = w - 3), w) : 0));
  }
  function u(b, m, O) {
    if ((m[0] & 192) !== 128)
      return b.lastNeed = 0, "�";
    if (b.lastNeed > 1 && m.length > 1) {
      if ((m[1] & 192) !== 128)
        return b.lastNeed = 1, "�";
      if (b.lastNeed > 2 && m.length > 2 && (m[2] & 192) !== 128)
        return b.lastNeed = 2, "�";
    }
  }
  function c(b) {
    var m = this.lastTotal - this.lastNeed, O = u(this, b);
    if (O !== void 0)
      return O;
    if (this.lastNeed <= b.length)
      return b.copy(this.lastChar, m, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    b.copy(this.lastChar, m, 0, b.length), this.lastNeed -= b.length;
  }
  function g(b, m) {
    var O = f(this, b, m);
    if (!this.lastNeed)
      return b.toString("utf8", m);
    this.lastTotal = O;
    var _ = b.length - (O - this.lastNeed);
    return b.copy(this.lastChar, 0, _), b.toString("utf8", m, _);
  }
  function y(b) {
    var m = b && b.length ? this.write(b) : "";
    return this.lastNeed ? m + "�" : m;
  }
  function p(b, m) {
    if ((b.length - m) % 2 === 0) {
      var O = b.toString("utf16le", m);
      if (O) {
        var _ = O.charCodeAt(O.length - 1);
        if (_ >= 55296 && _ <= 56319)
          return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = b[b.length - 2], this.lastChar[1] = b[b.length - 1], O.slice(0, -1);
      }
      return O;
    }
    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = b[b.length - 1], b.toString("utf16le", m, b.length - 1);
  }
  function R(b) {
    var m = b && b.length ? this.write(b) : "";
    if (this.lastNeed) {
      var O = this.lastTotal - this.lastNeed;
      return m + this.lastChar.toString("utf16le", 0, O);
    }
    return m;
  }
  function N(b, m) {
    var O = (b.length - m) % 3;
    return O === 0 ? b.toString("base64", m) : (this.lastNeed = 3 - O, this.lastTotal = 3, O === 1 ? this.lastChar[0] = b[b.length - 1] : (this.lastChar[0] = b[b.length - 2], this.lastChar[1] = b[b.length - 1]), b.toString("base64", m, b.length - O));
  }
  function D(b) {
    var m = b && b.length ? this.write(b) : "";
    return this.lastNeed ? m + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : m;
  }
  function x(b) {
    return b.toString(this.encoding);
  }
  function A(b) {
    return b && b.length ? this.write(b) : "";
  }
  return ht;
}
var pt, On;
function Qt() {
  if (On)
    return pt;
  On = 1;
  var e = gr().codes.ERR_STREAM_PREMATURE_CLOSE;
  function r(o) {
    var f = !1;
    return function() {
      if (!f) {
        f = !0;
        for (var u = arguments.length, c = new Array(u), g = 0; g < u; g++)
          c[g] = arguments[g];
        o.apply(this, c);
      }
    };
  }
  function t() {
  }
  function n(o) {
    return o.setHeader && typeof o.abort == "function";
  }
  function i(o, f, u) {
    if (typeof f == "function")
      return i(o, null, f);
    f || (f = {}), u = r(u || t);
    var c = f.readable || f.readable !== !1 && o.readable, g = f.writable || f.writable !== !1 && o.writable, y = function() {
      o.writable || R();
    }, p = o._writableState && o._writableState.finished, R = function() {
      g = !1, p = !0, c || u.call(o);
    }, N = o._readableState && o._readableState.endEmitted, D = function() {
      c = !1, N = !0, g || u.call(o);
    }, x = function(O) {
      u.call(o, O);
    }, A = function() {
      var O;
      if (c && !N)
        return (!o._readableState || !o._readableState.ended) && (O = new e()), u.call(o, O);
      if (g && !p)
        return (!o._writableState || !o._writableState.ended) && (O = new e()), u.call(o, O);
    }, b = function() {
      o.req.on("finish", R);
    };
    return n(o) ? (o.on("complete", R), o.on("abort", A), o.req ? b() : o.on("request", b)) : g && !o._writableState && (o.on("end", y), o.on("close", y)), o.on("end", D), o.on("finish", R), f.error !== !1 && o.on("error", x), o.on("close", A), function() {
      o.removeListener("complete", R), o.removeListener("abort", A), o.removeListener("request", b), o.req && o.req.removeListener("finish", R), o.removeListener("end", y), o.removeListener("close", y), o.removeListener("finish", R), o.removeListener("end", D), o.removeListener("error", x), o.removeListener("close", A);
    };
  }
  return pt = i, pt;
}
var gt, An;
function to() {
  if (An)
    return gt;
  An = 1;
  var e;
  function r(O, _, w) {
    return _ = t(_), _ in O ? Object.defineProperty(O, _, { value: w, enumerable: !0, configurable: !0, writable: !0 }) : O[_] = w, O;
  }
  function t(O) {
    var _ = n(O, "string");
    return typeof _ == "symbol" ? _ : String(_);
  }
  function n(O, _) {
    if (typeof O != "object" || O === null)
      return O;
    var w = O[Symbol.toPrimitive];
    if (w !== void 0) {
      var C = w.call(O, _ || "default");
      if (typeof C != "object")
        return C;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (_ === "string" ? String : Number)(O);
  }
  var i = Qt(), o = Symbol("lastResolve"), f = Symbol("lastReject"), u = Symbol("error"), c = Symbol("ended"), g = Symbol("lastPromise"), y = Symbol("handlePromise"), p = Symbol("stream");
  function R(O, _) {
    return {
      value: O,
      done: _
    };
  }
  function N(O) {
    var _ = O[o];
    if (_ !== null) {
      var w = O[p].read();
      w !== null && (O[g] = null, O[o] = null, O[f] = null, _(R(w, !1)));
    }
  }
  function D(O) {
    j.nextTick(N, O);
  }
  function x(O, _) {
    return function(w, C) {
      O.then(function() {
        if (_[c]) {
          w(R(void 0, !0));
          return;
        }
        _[y](w, C);
      }, C);
    };
  }
  var A = Object.getPrototypeOf(function() {
  }), b = Object.setPrototypeOf((e = {
    get stream() {
      return this[p];
    },
    next: function() {
      var _ = this, w = this[u];
      if (w !== null)
        return Promise.reject(w);
      if (this[c])
        return Promise.resolve(R(void 0, !0));
      if (this[p].destroyed)
        return new Promise(function(q, ae) {
          j.nextTick(function() {
            _[u] ? ae(_[u]) : q(R(void 0, !0));
          });
        });
      var C = this[g], F;
      if (C)
        F = new Promise(x(C, this));
      else {
        var B = this[p].read();
        if (B !== null)
          return Promise.resolve(R(B, !1));
        F = new Promise(this[y]);
      }
      return this[g] = F, F;
    }
  }, r(e, Symbol.asyncIterator, function() {
    return this;
  }), r(e, "return", function() {
    var _ = this;
    return new Promise(function(w, C) {
      _[p].destroy(null, function(F) {
        if (F) {
          C(F);
          return;
        }
        w(R(void 0, !0));
      });
    });
  }), e), A), m = function(_) {
    var w, C = Object.create(b, (w = {}, r(w, p, {
      value: _,
      writable: !0
    }), r(w, o, {
      value: null,
      writable: !0
    }), r(w, f, {
      value: null,
      writable: !0
    }), r(w, u, {
      value: null,
      writable: !0
    }), r(w, c, {
      value: _._readableState.endEmitted,
      writable: !0
    }), r(w, y, {
      value: function(B, q) {
        var ae = C[p].read();
        ae ? (C[g] = null, C[o] = null, C[f] = null, B(R(ae, !1))) : (C[o] = B, C[f] = q);
      },
      writable: !0
    }), w));
    return C[g] = null, i(_, function(F) {
      if (F && F.code !== "ERR_STREAM_PREMATURE_CLOSE") {
        var B = C[f];
        B !== null && (C[g] = null, C[o] = null, C[f] = null, B(F)), C[u] = F;
        return;
      }
      var q = C[o];
      q !== null && (C[g] = null, C[o] = null, C[f] = null, q(R(void 0, !0))), C[c] = !0;
    }), _.on("readable", D.bind(null, C)), C;
  };
  return gt = m, gt;
}
var bt, Ln;
function no() {
  return Ln || (Ln = 1, bt = function() {
    throw new Error("Readable.from is not available in the browser");
  }), bt;
}
var vt, Pn;
function Ri() {
  if (Pn)
    return vt;
  Pn = 1, vt = q;
  var e;
  q.ReadableState = B, pr.EventEmitter;
  var r = function(l, M) {
    return l.listeners(M).length;
  }, t = mi(), n = ne.Buffer, i = (typeof Ae < "u" ? Ae : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function o(d) {
    return n.from(d);
  }
  function f(d) {
    return n.isBuffer(d) || d instanceof i;
  }
  var u = Gr, c;
  u && u.debuglog ? c = u.debuglog("stream") : c = function() {
  };
  var g = eo(), y = wi(), p = _i(), R = p.getHighWaterMark, N = gr().codes, D = N.ERR_INVALID_ARG_TYPE, x = N.ERR_STREAM_PUSH_AFTER_EOF, A = N.ERR_METHOD_NOT_IMPLEMENTED, b = N.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, m, O, _;
  ue(q, t);
  var w = y.errorOrDestroy, C = ["error", "close", "destroy", "pause", "resume"];
  function F(d, l, M) {
    if (typeof d.prependListener == "function")
      return d.prependListener(l, M);
    !d._events || !d._events[l] ? d.on(l, M) : Array.isArray(d._events[l]) ? d._events[l].unshift(M) : d._events[l] = [M, d._events[l]];
  }
  function B(d, l, M) {
    e = e || sr(), d = d || {}, typeof M != "boolean" && (M = l instanceof e), this.objectMode = !!d.objectMode, M && (this.objectMode = this.objectMode || !!d.readableObjectMode), this.highWaterMark = R(this, d, "readableHighWaterMark", M), this.buffer = new g(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = d.emitClose !== !1, this.autoDestroy = !!d.autoDestroy, this.destroyed = !1, this.defaultEncoding = d.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, d.encoding && (m || (m = ur().StringDecoder), this.decoder = new m(d.encoding), this.encoding = d.encoding);
  }
  function q(d) {
    if (e = e || sr(), !(this instanceof q))
      return new q(d);
    var l = this instanceof e;
    this._readableState = new B(d, this, l), this.readable = !0, d && (typeof d.read == "function" && (this._read = d.read), typeof d.destroy == "function" && (this._destroy = d.destroy)), t.call(this);
  }
  Object.defineProperty(q.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(l) {
      this._readableState && (this._readableState.destroyed = l);
    }
  }), q.prototype.destroy = y.destroy, q.prototype._undestroy = y.undestroy, q.prototype._destroy = function(d, l) {
    l(d);
  }, q.prototype.push = function(d, l) {
    var M = this._readableState, I;
    return M.objectMode ? I = !0 : typeof d == "string" && (l = l || M.defaultEncoding, l !== M.encoding && (d = n.from(d, l), l = ""), I = !0), ae(this, d, l, !1, I);
  }, q.prototype.unshift = function(d) {
    return ae(this, d, null, !0, !1);
  };
  function ae(d, l, M, I, Q) {
    c("readableAddChunk", l);
    var $ = d._readableState;
    if (l === null)
      $.reading = !1, ze(d, $);
    else {
      var K;
      if (Q || (K = Ie($, l)), K)
        w(d, K);
      else if ($.objectMode || l && l.length > 0)
        if (typeof l != "string" && !$.objectMode && Object.getPrototypeOf(l) !== n.prototype && (l = o(l)), I)
          $.endEmitted ? w(d, new b()) : de(d, $, l, !0);
        else if ($.ended)
          w(d, new x());
        else {
          if ($.destroyed)
            return !1;
          $.reading = !1, $.decoder && !M ? (l = $.decoder.write(l), $.objectMode || l.length !== 0 ? de(d, $, l, !1) : P(d, $)) : de(d, $, l, !1);
        }
      else
        I || ($.reading = !1, P(d, $));
    }
    return !$.ended && ($.length < $.highWaterMark || $.length === 0);
  }
  function de(d, l, M, I) {
    l.flowing && l.length === 0 && !l.sync ? (l.awaitDrain = 0, d.emit("data", M)) : (l.length += l.objectMode ? 1 : M.length, I ? l.buffer.unshift(M) : l.buffer.push(M), l.needReadable && E(d)), P(d, l);
  }
  function Ie(d, l) {
    var M;
    return !f(l) && typeof l != "string" && l !== void 0 && !d.objectMode && (M = new D("chunk", ["string", "Buffer", "Uint8Array"], l)), M;
  }
  q.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, q.prototype.setEncoding = function(d) {
    m || (m = ur().StringDecoder);
    var l = new m(d);
    this._readableState.decoder = l, this._readableState.encoding = this._readableState.decoder.encoding;
    for (var M = this._readableState.buffer.head, I = ""; M !== null; )
      I += l.write(M.data), M = M.next;
    return this._readableState.buffer.clear(), I !== "" && this._readableState.buffer.push(I), this._readableState.length = I.length, this;
  };
  var me = 1073741824;
  function we(d) {
    return d >= me ? d = me : (d--, d |= d >>> 1, d |= d >>> 2, d |= d >>> 4, d |= d >>> 8, d |= d >>> 16, d++), d;
  }
  function Be(d, l) {
    return d <= 0 || l.length === 0 && l.ended ? 0 : l.objectMode ? 1 : d !== d ? l.flowing && l.length ? l.buffer.head.data.length : l.length : (d > l.highWaterMark && (l.highWaterMark = we(d)), d <= l.length ? d : l.ended ? l.length : (l.needReadable = !0, 0));
  }
  q.prototype.read = function(d) {
    c("read", d), d = parseInt(d, 10);
    var l = this._readableState, M = d;
    if (d !== 0 && (l.emittedReadable = !1), d === 0 && l.needReadable && ((l.highWaterMark !== 0 ? l.length >= l.highWaterMark : l.length > 0) || l.ended))
      return c("read: emitReadable", l.length, l.ended), l.length === 0 && l.ended ? s(this) : E(this), null;
    if (d = Be(d, l), d === 0 && l.ended)
      return l.length === 0 && s(this), null;
    var I = l.needReadable;
    c("need readable", I), (l.length === 0 || l.length - d < l.highWaterMark) && (I = !0, c("length less than watermark", I)), l.ended || l.reading ? (I = !1, c("reading or ended", I)) : I && (c("do read"), l.reading = !0, l.sync = !0, l.length === 0 && (l.needReadable = !0), this._read(l.highWaterMark), l.sync = !1, l.reading || (d = Be(M, l)));
    var Q;
    return d > 0 ? Q = a(d, l) : Q = null, Q === null ? (l.needReadable = l.length <= l.highWaterMark, d = 0) : (l.length -= d, l.awaitDrain = 0), l.length === 0 && (l.ended || (l.needReadable = !0), M !== d && l.ended && s(this)), Q !== null && this.emit("data", Q), Q;
  };
  function ze(d, l) {
    if (c("onEofChunk"), !l.ended) {
      if (l.decoder) {
        var M = l.decoder.end();
        M && M.length && (l.buffer.push(M), l.length += l.objectMode ? 1 : M.length);
      }
      l.ended = !0, l.sync ? E(d) : (l.needReadable = !1, l.emittedReadable || (l.emittedReadable = !0, k(d)));
    }
  }
  function E(d) {
    var l = d._readableState;
    c("emitReadable", l.needReadable, l.emittedReadable), l.needReadable = !1, l.emittedReadable || (c("emitReadable", l.flowing), l.emittedReadable = !0, j.nextTick(k, d));
  }
  function k(d) {
    var l = d._readableState;
    c("emitReadable_", l.destroyed, l.length, l.ended), !l.destroyed && (l.length || l.ended) && (d.emit("readable"), l.emittedReadable = !1), l.needReadable = !l.flowing && !l.ended && l.length <= l.highWaterMark, S(d);
  }
  function P(d, l) {
    l.readingMore || (l.readingMore = !0, j.nextTick(H, d, l));
  }
  function H(d, l) {
    for (; !l.reading && !l.ended && (l.length < l.highWaterMark || l.flowing && l.length === 0); ) {
      var M = l.length;
      if (c("maybeReadMore read 0"), d.read(0), M === l.length)
        break;
    }
    l.readingMore = !1;
  }
  q.prototype._read = function(d) {
    w(this, new A("_read()"));
  }, q.prototype.pipe = function(d, l) {
    var M = this, I = this._readableState;
    switch (I.pipesCount) {
      case 0:
        I.pipes = d;
        break;
      case 1:
        I.pipes = [I.pipes, d];
        break;
      default:
        I.pipes.push(d);
        break;
    }
    I.pipesCount += 1, c("pipe count=%d opts=%j", I.pipesCount, l);
    var Q = (!l || l.end !== !1) && d !== j.stdout && d !== j.stderr, $ = Q ? Te : yr;
    I.endEmitted ? j.nextTick($) : M.once("end", $), d.on("unpipe", K);
    function K(Je, Qe) {
      c("onunpipe"), Je === M && Qe && Qe.hasUnpiped === !1 && (Qe.hasUnpiped = !0, vr());
    }
    function Te() {
      c("onend"), d.end();
    }
    var Ge = U(M);
    d.on("drain", Ge);
    var Xe = !1;
    function vr() {
      c("cleanup"), d.removeListener("close", ke), d.removeListener("finish", Ne), d.removeListener("drain", Ge), d.removeListener("error", Pe), d.removeListener("unpipe", K), M.removeListener("end", Te), M.removeListener("end", yr), M.removeListener("data", Ze), Xe = !0, I.awaitDrain && (!d._writableState || d._writableState.needDrain) && Ge();
    }
    M.on("data", Ze);
    function Ze(Je) {
      c("ondata");
      var Qe = d.write(Je);
      c("dest.write", Qe), Qe === !1 && ((I.pipesCount === 1 && I.pipes === d || I.pipesCount > 1 && L(I.pipes, d) !== -1) && !Xe && (c("false write response, pause", I.awaitDrain), I.awaitDrain++), M.pause());
    }
    function Pe(Je) {
      c("onerror", Je), yr(), d.removeListener("error", Pe), r(d, "error") === 0 && w(d, Je);
    }
    F(d, "error", Pe);
    function ke() {
      d.removeListener("finish", Ne), yr();
    }
    d.once("close", ke);
    function Ne() {
      c("onfinish"), d.removeListener("close", ke), yr();
    }
    d.once("finish", Ne);
    function yr() {
      c("unpipe"), M.unpipe(d);
    }
    return d.emit("pipe", M), I.flowing || (c("pipe resume"), M.resume()), d;
  };
  function U(d) {
    return function() {
      var M = d._readableState;
      c("pipeOnDrain", M.awaitDrain), M.awaitDrain && M.awaitDrain--, M.awaitDrain === 0 && r(d, "data") && (M.flowing = !0, S(d));
    };
  }
  q.prototype.unpipe = function(d) {
    var l = this._readableState, M = {
      hasUnpiped: !1
    };
    if (l.pipesCount === 0)
      return this;
    if (l.pipesCount === 1)
      return d && d !== l.pipes ? this : (d || (d = l.pipes), l.pipes = null, l.pipesCount = 0, l.flowing = !1, d && d.emit("unpipe", this, M), this);
    if (!d) {
      var I = l.pipes, Q = l.pipesCount;
      l.pipes = null, l.pipesCount = 0, l.flowing = !1;
      for (var $ = 0; $ < Q; $++)
        I[$].emit("unpipe", this, {
          hasUnpiped: !1
        });
      return this;
    }
    var K = L(l.pipes, d);
    return K === -1 ? this : (l.pipes.splice(K, 1), l.pipesCount -= 1, l.pipesCount === 1 && (l.pipes = l.pipes[0]), d.emit("unpipe", this, M), this);
  }, q.prototype.on = function(d, l) {
    var M = t.prototype.on.call(this, d, l), I = this._readableState;
    return d === "data" ? (I.readableListening = this.listenerCount("readable") > 0, I.flowing !== !1 && this.resume()) : d === "readable" && !I.endEmitted && !I.readableListening && (I.readableListening = I.needReadable = !0, I.flowing = !1, I.emittedReadable = !1, c("on readable", I.length, I.reading), I.length ? E(this) : I.reading || j.nextTick(oe, this)), M;
  }, q.prototype.addListener = q.prototype.on, q.prototype.removeListener = function(d, l) {
    var M = t.prototype.removeListener.call(this, d, l);
    return d === "readable" && j.nextTick(z, this), M;
  }, q.prototype.removeAllListeners = function(d) {
    var l = t.prototype.removeAllListeners.apply(this, arguments);
    return (d === "readable" || d === void 0) && j.nextTick(z, this), l;
  };
  function z(d) {
    var l = d._readableState;
    l.readableListening = d.listenerCount("readable") > 0, l.resumeScheduled && !l.paused ? l.flowing = !0 : d.listenerCount("data") > 0 && d.resume();
  }
  function oe(d) {
    c("readable nexttick read 0"), d.read(0);
  }
  q.prototype.resume = function() {
    var d = this._readableState;
    return d.flowing || (c("resume"), d.flowing = !d.readableListening, ce(this, d)), d.paused = !1, this;
  };
  function ce(d, l) {
    l.resumeScheduled || (l.resumeScheduled = !0, j.nextTick(_e, d, l));
  }
  function _e(d, l) {
    c("resume", l.reading), l.reading || d.read(0), l.resumeScheduled = !1, d.emit("resume"), S(d), l.flowing && !l.reading && d.read(0);
  }
  q.prototype.pause = function() {
    return c("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (c("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
  };
  function S(d) {
    var l = d._readableState;
    for (c("flow", l.flowing); l.flowing && d.read() !== null; )
      ;
  }
  q.prototype.wrap = function(d) {
    var l = this, M = this._readableState, I = !1;
    d.on("end", function() {
      if (c("wrapped end"), M.decoder && !M.ended) {
        var K = M.decoder.end();
        K && K.length && l.push(K);
      }
      l.push(null);
    }), d.on("data", function(K) {
      if (c("wrapped data"), M.decoder && (K = M.decoder.write(K)), !(M.objectMode && K == null) && !(!M.objectMode && (!K || !K.length))) {
        var Te = l.push(K);
        Te || (I = !0, d.pause());
      }
    });
    for (var Q in d)
      this[Q] === void 0 && typeof d[Q] == "function" && (this[Q] = function(Te) {
        return function() {
          return d[Te].apply(d, arguments);
        };
      }(Q));
    for (var $ = 0; $ < C.length; $++)
      d.on(C[$], this.emit.bind(this, C[$]));
    return this._read = function(K) {
      c("wrapped _read", K), I && (I = !1, d.resume());
    }, this;
  }, typeof Symbol == "function" && (q.prototype[Symbol.asyncIterator] = function() {
    return O === void 0 && (O = to()), O(this);
  }), Object.defineProperty(q.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), Object.defineProperty(q.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState && this._readableState.buffer;
    }
  }), Object.defineProperty(q.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.flowing;
    },
    set: function(l) {
      this._readableState && (this._readableState.flowing = l);
    }
  }), q._fromList = a, Object.defineProperty(q.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.length;
    }
  });
  function a(d, l) {
    if (l.length === 0)
      return null;
    var M;
    return l.objectMode ? M = l.buffer.shift() : !d || d >= l.length ? (l.decoder ? M = l.buffer.join("") : l.buffer.length === 1 ? M = l.buffer.first() : M = l.buffer.concat(l.length), l.buffer.clear()) : M = l.buffer.consume(d, l.decoder), M;
  }
  function s(d) {
    var l = d._readableState;
    c("endReadable", l.endEmitted), l.endEmitted || (l.ended = !0, j.nextTick(T, l, d));
  }
  function T(d, l) {
    if (c("endReadableNT", d.endEmitted, d.length), !d.endEmitted && d.length === 0 && (d.endEmitted = !0, l.readable = !1, l.emit("end"), d.autoDestroy)) {
      var M = l._writableState;
      (!M || M.autoDestroy && M.finished) && l.destroy();
    }
  }
  typeof Symbol == "function" && (q.from = function(d, l) {
    return _ === void 0 && (_ = no()), _(q, d, l);
  });
  function L(d, l) {
    for (var M = 0, I = d.length; M < I; M++)
      if (d[M] === l)
        return M;
    return -1;
  }
  return vt;
}
var yt, Nn;
function xi() {
  if (Nn)
    return yt;
  Nn = 1, yt = u;
  var e = gr().codes, r = e.ERR_METHOD_NOT_IMPLEMENTED, t = e.ERR_MULTIPLE_CALLBACK, n = e.ERR_TRANSFORM_ALREADY_TRANSFORMING, i = e.ERR_TRANSFORM_WITH_LENGTH_0, o = sr();
  ue(u, o);
  function f(y, p) {
    var R = this._transformState;
    R.transforming = !1;
    var N = R.writecb;
    if (N === null)
      return this.emit("error", new t());
    R.writechunk = null, R.writecb = null, p != null && this.push(p), N(y);
    var D = this._readableState;
    D.reading = !1, (D.needReadable || D.length < D.highWaterMark) && this._read(D.highWaterMark);
  }
  function u(y) {
    if (!(this instanceof u))
      return new u(y);
    o.call(this, y), this._transformState = {
      afterTransform: f.bind(this),
      needTransform: !1,
      transforming: !1,
      writecb: null,
      writechunk: null,
      writeencoding: null
    }, this._readableState.needReadable = !0, this._readableState.sync = !1, y && (typeof y.transform == "function" && (this._transform = y.transform), typeof y.flush == "function" && (this._flush = y.flush)), this.on("prefinish", c);
  }
  function c() {
    var y = this;
    typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function(p, R) {
      g(y, p, R);
    }) : g(this, null, null);
  }
  u.prototype.push = function(y, p) {
    return this._transformState.needTransform = !1, o.prototype.push.call(this, y, p);
  }, u.prototype._transform = function(y, p, R) {
    R(new r("_transform()"));
  }, u.prototype._write = function(y, p, R) {
    var N = this._transformState;
    if (N.writecb = R, N.writechunk = y, N.writeencoding = p, !N.transforming) {
      var D = this._readableState;
      (N.needTransform || D.needReadable || D.length < D.highWaterMark) && this._read(D.highWaterMark);
    }
  }, u.prototype._read = function(y) {
    var p = this._transformState;
    p.writechunk !== null && !p.transforming ? (p.transforming = !0, this._transform(p.writechunk, p.writeencoding, p.afterTransform)) : p.needTransform = !0;
  }, u.prototype._destroy = function(y, p) {
    o.prototype._destroy.call(this, y, function(R) {
      p(R);
    });
  };
  function g(y, p, R) {
    if (p)
      return y.emit("error", p);
    if (R != null && y.push(R), y._writableState.length)
      throw new i();
    if (y._transformState.transforming)
      throw new n();
    return y.push(null);
  }
  return yt;
}
var mt, Fn;
function io() {
  if (Fn)
    return mt;
  Fn = 1, mt = r;
  var e = xi();
  ue(r, e);
  function r(t) {
    if (!(this instanceof r))
      return new r(t);
    e.call(this, t);
  }
  return r.prototype._transform = function(t, n, i) {
    i(null, t);
  }, mt;
}
var wt, jn;
function ao() {
  if (jn)
    return wt;
  jn = 1;
  var e;
  function r(R) {
    var N = !1;
    return function() {
      N || (N = !0, R.apply(void 0, arguments));
    };
  }
  var t = gr().codes, n = t.ERR_MISSING_ARGS, i = t.ERR_STREAM_DESTROYED;
  function o(R) {
    if (R)
      throw R;
  }
  function f(R) {
    return R.setHeader && typeof R.abort == "function";
  }
  function u(R, N, D, x) {
    x = r(x);
    var A = !1;
    R.on("close", function() {
      A = !0;
    }), e === void 0 && (e = Qt()), e(R, {
      readable: N,
      writable: D
    }, function(m) {
      if (m)
        return x(m);
      A = !0, x();
    });
    var b = !1;
    return function(m) {
      if (!A && !b) {
        if (b = !0, f(R))
          return R.abort();
        if (typeof R.destroy == "function")
          return R.destroy();
        x(m || new i("pipe"));
      }
    };
  }
  function c(R) {
    R();
  }
  function g(R, N) {
    return R.pipe(N);
  }
  function y(R) {
    return !R.length || typeof R[R.length - 1] != "function" ? o : R.pop();
  }
  function p() {
    for (var R = arguments.length, N = new Array(R), D = 0; D < R; D++)
      N[D] = arguments[D];
    var x = y(N);
    if (Array.isArray(N[0]) && (N = N[0]), N.length < 2)
      throw new n("streams");
    var A, b = N.map(function(m, O) {
      var _ = O < N.length - 1, w = O > 0;
      return u(m, _, w, function(C) {
        A || (A = C), C && b.forEach(c), !_ && (b.forEach(c), x(A));
      });
    });
    return N.reduce(g);
  }
  return wt = p, wt;
}
var Ke = ye, en = pr.EventEmitter, oo = ue;
oo(ye, en);
ye.Readable = Ri();
ye.Writable = Ei();
ye.Duplex = sr();
ye.Transform = xi();
ye.PassThrough = io();
ye.finished = Qt();
ye.pipeline = ao();
ye.Stream = ye;
function ye() {
  en.call(this);
}
ye.prototype.pipe = function(e, r) {
  var t = this;
  function n(y) {
    e.writable && e.write(y) === !1 && t.pause && t.pause();
  }
  t.on("data", n);
  function i() {
    t.readable && t.resume && t.resume();
  }
  e.on("drain", i), !e._isStdio && (!r || r.end !== !1) && (t.on("end", f), t.on("close", u));
  var o = !1;
  function f() {
    o || (o = !0, e.end());
  }
  function u() {
    o || (o = !0, typeof e.destroy == "function" && e.destroy());
  }
  function c(y) {
    if (g(), en.listenerCount(this, "error") === 0)
      throw y;
  }
  t.on("error", c), e.on("error", c);
  function g() {
    t.removeListener("data", n), e.removeListener("drain", i), t.removeListener("end", f), t.removeListener("close", u), t.removeListener("error", c), e.removeListener("error", c), t.removeListener("end", g), t.removeListener("close", g), e.removeListener("close", g);
  }
  return t.on("end", g), t.on("close", g), e.on("close", g), e.emit("pipe", t), e;
};
(function(e, r) {
  var t = Ke;
  e.exports = n, n.through = n;
  function n(i, o, f) {
    i = i || function(D) {
      this.queue(D);
    }, o = o || function() {
      this.queue(null);
    };
    var u = !1, c = !1, g = [], y = !1, p = new t();
    p.readable = p.writable = !0, p.paused = !1, p.autoDestroy = !(f && f.autoDestroy === !1), p.write = function(D) {
      return i.call(this, D), !p.paused;
    };
    function R() {
      for (; g.length && !p.paused; ) {
        var D = g.shift();
        if (D === null)
          return p.emit("end");
        p.emit("data", D);
      }
    }
    p.queue = p.push = function(D) {
      return y || (D === null && (y = !0), g.push(D), R()), p;
    }, p.on("end", function() {
      p.readable = !1, !p.writable && p.autoDestroy && j.nextTick(function() {
        p.destroy();
      });
    });
    function N() {
      p.writable = !1, o.call(p), !p.readable && p.autoDestroy && p.destroy();
    }
    return p.end = function(D) {
      if (!u)
        return u = !0, arguments.length && p.write(D), N(), p;
    }, p.destroy = function() {
      if (!c)
        return c = !0, u = !0, g.length = 0, p.writable = p.readable = !1, p.emit("close"), p;
    }, p.pause = function() {
      if (!p.paused)
        return p.paused = !0, p;
    }, p.resume = function() {
      return p.paused && (p.paused = !1, p.emit("resume")), R(), p.paused || p.emit("drain"), p;
    }, p;
  }
})(li);
var fo = li.exports;
const so = /* @__PURE__ */ Gt(fo);
var uo = Object.prototype.toString, rn = typeof ne.Buffer.alloc == "function" && typeof ne.Buffer.allocUnsafe == "function" && typeof ne.Buffer.from == "function";
function lo(e) {
  return uo.call(e).slice(8, -1) === "ArrayBuffer";
}
function co(e, r, t) {
  r >>>= 0;
  var n = e.byteLength - r;
  if (n < 0)
    throw new RangeError("'offset' is out of bounds");
  if (t === void 0)
    t = n;
  else if (t >>>= 0, t > n)
    throw new RangeError("'length' is out of bounds");
  return rn ? ne.Buffer.from(e.slice(r, r + t)) : new ne.Buffer(new Uint8Array(e.slice(r, r + t)));
}
function ho(e, r) {
  if ((typeof r != "string" || r === "") && (r = "utf8"), !ne.Buffer.isEncoding(r))
    throw new TypeError('"encoding" must be a valid string encoding');
  return rn ? ne.Buffer.from(e, r) : new ne.Buffer(e, r);
}
function po(e, r, t) {
  if (typeof e == "number")
    throw new TypeError('"value" argument must not be a number');
  return lo(e) ? co(e, r, t) : typeof e == "string" ? ho(e, r) : rn ? ne.Buffer.from(e) : new ne.Buffer(e);
}
var go = po, At = { exports: {} }, bo = Array.isArray || function(e) {
  return Object.prototype.toString.call(e) == "[object Array]";
}, ee = {};
function vo(e) {
  return Array.isArray ? Array.isArray(e) : Zr(e) === "[object Array]";
}
ee.isArray = vo;
function yo(e) {
  return typeof e == "boolean";
}
ee.isBoolean = yo;
function mo(e) {
  return e === null;
}
ee.isNull = mo;
function wo(e) {
  return e == null;
}
ee.isNullOrUndefined = wo;
function _o(e) {
  return typeof e == "number";
}
ee.isNumber = _o;
function So(e) {
  return typeof e == "string";
}
ee.isString = So;
function Eo(e) {
  return typeof e == "symbol";
}
ee.isSymbol = Eo;
function Ro(e) {
  return e === void 0;
}
ee.isUndefined = Ro;
function xo(e) {
  return Zr(e) === "[object RegExp]";
}
ee.isRegExp = xo;
function To(e) {
  return typeof e == "object" && e !== null;
}
ee.isObject = To;
function ko(e) {
  return Zr(e) === "[object Date]";
}
ee.isDate = ko;
function Mo(e) {
  return Zr(e) === "[object Error]" || e instanceof Error;
}
ee.isError = Mo;
function Co(e) {
  return typeof e == "function";
}
ee.isFunction = Co;
function Do(e) {
  return e === null || typeof e == "boolean" || typeof e == "number" || typeof e == "string" || typeof e == "symbol" || // ES6 symbol
  typeof e > "u";
}
ee.isPrimitive = Do;
ee.isBuffer = ne.Buffer.isBuffer;
function Zr(e) {
  return Object.prototype.toString.call(e);
}
var Ti = fe, Oo = bo, Hr = ne.Buffer;
fe.ReadableState = Mi;
var $r = pr.EventEmitter;
$r.listenerCount || ($r.listenerCount = function(e, r) {
  return e.listeners(r).length;
});
var Rr = Ke, ki = ee;
ki.inherits = ue;
var or;
ki.inherits(fe, Rr);
function Mi(e, r) {
  e = e || {};
  var t = e.highWaterMark;
  this.highWaterMark = t || t === 0 ? t : 16 * 1024, this.highWaterMark = ~~this.highWaterMark, this.buffer = [], this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = !1, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.calledRead = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.objectMode = !!e.objectMode, this.defaultEncoding = e.defaultEncoding || "utf8", this.ranOut = !1, this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, e.encoding && (or || (or = ur().StringDecoder), this.decoder = new or(e.encoding), this.encoding = e.encoding);
}
function fe(e) {
  if (!(this instanceof fe))
    return new fe(e);
  this._readableState = new Mi(e), this.readable = !0, Rr.call(this);
}
fe.prototype.push = function(e, r) {
  var t = this._readableState;
  return typeof e == "string" && !t.objectMode && (r = r || t.defaultEncoding, r !== t.encoding && (e = new Hr(e, r), r = "")), Ci(this, t, e, r, !1);
};
fe.prototype.unshift = function(e) {
  var r = this._readableState;
  return Ci(this, r, e, "", !0);
};
function Ci(e, r, t, n, i) {
  var o = Po(r, t);
  if (o)
    e.emit("error", o);
  else if (t == null)
    r.reading = !1, r.ended || No(e, r);
  else if (r.objectMode || t && t.length > 0)
    if (r.ended && !i) {
      var f = new Error("stream.push() after EOF");
      e.emit("error", f);
    } else if (r.endEmitted && i) {
      var f = new Error("stream.unshift() after end event");
      e.emit("error", f);
    } else
      r.decoder && !i && !n && (t = r.decoder.write(t)), r.length += r.objectMode ? 1 : t.length, i ? r.buffer.unshift(t) : (r.reading = !1, r.buffer.push(t)), r.needReadable && Jr(e), Fo(e, r);
  else
    i || (r.reading = !1);
  return Ao(r);
}
function Ao(e) {
  return !e.ended && (e.needReadable || e.length < e.highWaterMark || e.length === 0);
}
fe.prototype.setEncoding = function(e) {
  or || (or = ur().StringDecoder), this._readableState.decoder = new or(e), this._readableState.encoding = e;
};
var In = 8388608;
function Lo(e) {
  if (e >= In)
    e = In;
  else {
    e--;
    for (var r = 1; r < 32; r <<= 1)
      e |= e >> r;
    e++;
  }
  return e;
}
function Bn(e, r) {
  return r.length === 0 && r.ended ? 0 : r.objectMode ? e === 0 ? 0 : 1 : e === null || isNaN(e) ? r.flowing && r.buffer.length ? r.buffer[0].length : r.length : e <= 0 ? 0 : (e > r.highWaterMark && (r.highWaterMark = Lo(e)), e > r.length ? r.ended ? r.length : (r.needReadable = !0, 0) : e);
}
fe.prototype.read = function(e) {
  var r = this._readableState;
  r.calledRead = !0;
  var t = e, n;
  if ((typeof e != "number" || e > 0) && (r.emittedReadable = !1), e === 0 && r.needReadable && (r.length >= r.highWaterMark || r.ended))
    return Jr(this), null;
  if (e = Bn(e, r), e === 0 && r.ended)
    return n = null, r.length > 0 && r.decoder && (n = Pt(e, r), r.length -= n.length), r.length === 0 && Nt(this), n;
  var i = r.needReadable;
  return r.length - e <= r.highWaterMark && (i = !0), (r.ended || r.reading) && (i = !1), i && (r.reading = !0, r.sync = !0, r.length === 0 && (r.needReadable = !0), this._read(r.highWaterMark), r.sync = !1), i && !r.reading && (e = Bn(t, r)), e > 0 ? n = Pt(e, r) : n = null, n === null && (r.needReadable = !0, e = 0), r.length -= e, r.length === 0 && !r.ended && (r.needReadable = !0), r.ended && !r.endEmitted && r.length === 0 && Nt(this), n;
};
function Po(e, r) {
  var t = null;
  return !Hr.isBuffer(r) && typeof r != "string" && r !== null && r !== void 0 && !e.objectMode && (t = new TypeError("Invalid non-string/buffer chunk")), t;
}
function No(e, r) {
  if (r.decoder && !r.ended) {
    var t = r.decoder.end();
    t && t.length && (r.buffer.push(t), r.length += r.objectMode ? 1 : t.length);
  }
  r.ended = !0, r.length > 0 ? Jr(e) : Nt(e);
}
function Jr(e) {
  var r = e._readableState;
  r.needReadable = !1, !r.emittedReadable && (r.emittedReadable = !0, r.sync ? j.nextTick(function() {
    qn(e);
  }) : qn(e));
}
function qn(e) {
  e.emit("readable");
}
function Fo(e, r) {
  r.readingMore || (r.readingMore = !0, j.nextTick(function() {
    jo(e, r);
  }));
}
function jo(e, r) {
  for (var t = r.length; !r.reading && !r.flowing && !r.ended && r.length < r.highWaterMark && (e.read(0), t !== r.length); )
    t = r.length;
  r.readingMore = !1;
}
fe.prototype._read = function(e) {
  this.emit("error", new Error("not implemented"));
};
fe.prototype.pipe = function(e, r) {
  var t = this, n = this._readableState;
  switch (n.pipesCount) {
    case 0:
      n.pipes = e;
      break;
    case 1:
      n.pipes = [n.pipes, e];
      break;
    default:
      n.pipes.push(e);
      break;
  }
  n.pipesCount += 1;
  var i = (!r || r.end !== !1) && e !== j.stdout && e !== j.stderr, o = i ? u : g;
  n.endEmitted ? j.nextTick(o) : t.once("end", o), e.on("unpipe", f);
  function f(D) {
    D === t && g();
  }
  function u() {
    e.end();
  }
  var c = Io(t);
  e.on("drain", c);
  function g() {
    e.removeListener("close", p), e.removeListener("finish", R), e.removeListener("drain", c), e.removeListener("error", y), e.removeListener("unpipe", f), t.removeListener("end", u), t.removeListener("end", g), (!e._writableState || e._writableState.needDrain) && c();
  }
  function y(D) {
    N(), e.removeListener("error", y), $r.listenerCount(e, "error") === 0 && e.emit("error", D);
  }
  !e._events || !e._events.error ? e.on("error", y) : Oo(e._events.error) ? e._events.error.unshift(y) : e._events.error = [y, e._events.error];
  function p() {
    e.removeListener("finish", R), N();
  }
  e.once("close", p);
  function R() {
    e.removeListener("close", p), N();
  }
  e.once("finish", R);
  function N() {
    t.unpipe(e);
  }
  return e.emit("pipe", t), n.flowing || (this.on("readable", Lt), n.flowing = !0, j.nextTick(function() {
    tn(t);
  })), e;
};
function Io(e) {
  return function() {
    var r = e._readableState;
    r.awaitDrain--, r.awaitDrain === 0 && tn(e);
  };
}
function tn(e) {
  var r = e._readableState, t;
  r.awaitDrain = 0;
  function n(i, o, f) {
    var u = i.write(t);
    u === !1 && r.awaitDrain++;
  }
  for (; r.pipesCount && (t = e.read()) !== null; )
    if (r.pipesCount === 1 ? n(r.pipes) : Di(r.pipes, n), e.emit("data", t), r.awaitDrain > 0)
      return;
  if (r.pipesCount === 0) {
    r.flowing = !1, $r.listenerCount(e, "data") > 0 && Qr(e);
    return;
  }
  r.ranOut = !0;
}
function Lt() {
  this._readableState.ranOut && (this._readableState.ranOut = !1, tn(this));
}
fe.prototype.unpipe = function(e) {
  var r = this._readableState;
  if (r.pipesCount === 0)
    return this;
  if (r.pipesCount === 1)
    return e && e !== r.pipes ? this : (e || (e = r.pipes), r.pipes = null, r.pipesCount = 0, this.removeListener("readable", Lt), r.flowing = !1, e && e.emit("unpipe", this), this);
  if (!e) {
    var t = r.pipes, n = r.pipesCount;
    r.pipes = null, r.pipesCount = 0, this.removeListener("readable", Lt), r.flowing = !1;
    for (var i = 0; i < n; i++)
      t[i].emit("unpipe", this);
    return this;
  }
  var i = Bo(r.pipes, e);
  return i === -1 ? this : (r.pipes.splice(i, 1), r.pipesCount -= 1, r.pipesCount === 1 && (r.pipes = r.pipes[0]), e.emit("unpipe", this), this);
};
fe.prototype.on = function(e, r) {
  var t = Rr.prototype.on.call(this, e, r);
  if (e === "data" && !this._readableState.flowing && Qr(this), e === "readable" && this.readable) {
    var n = this._readableState;
    n.readableListening || (n.readableListening = !0, n.emittedReadable = !1, n.needReadable = !0, n.reading ? n.length && Jr(this) : this.read(0));
  }
  return t;
};
fe.prototype.addListener = fe.prototype.on;
fe.prototype.resume = function() {
  Qr(this), this.read(0), this.emit("resume");
};
fe.prototype.pause = function() {
  Qr(this, !0), this.emit("pause");
};
function Qr(e, r) {
  var t = e._readableState;
  if (t.flowing)
    throw new Error("Cannot switch to old mode now.");
  var n = r || !1, i = !1;
  e.readable = !0, e.pipe = Rr.prototype.pipe, e.on = e.addListener = Rr.prototype.on, e.on("readable", function() {
    i = !0;
    for (var o; !n && (o = e.read()) !== null; )
      e.emit("data", o);
    o === null && (i = !1, e._readableState.needReadable = !0);
  }), e.pause = function() {
    n = !0, this.emit("pause");
  }, e.resume = function() {
    n = !1, i ? j.nextTick(function() {
      e.emit("readable");
    }) : this.read(0), this.emit("resume");
  }, e.emit("readable");
}
fe.prototype.wrap = function(e) {
  var r = this._readableState, t = !1, n = this;
  e.on("end", function() {
    if (r.decoder && !r.ended) {
      var f = r.decoder.end();
      f && f.length && n.push(f);
    }
    n.push(null);
  }), e.on("data", function(f) {
    if (r.decoder && (f = r.decoder.write(f)), !(r.objectMode && f == null) && !(!r.objectMode && (!f || !f.length))) {
      var u = n.push(f);
      u || (t = !0, e.pause());
    }
  });
  for (var i in e)
    typeof e[i] == "function" && typeof this[i] > "u" && (this[i] = function(f) {
      return function() {
        return e[f].apply(e, arguments);
      };
    }(i));
  var o = ["error", "close", "destroy", "pause", "resume"];
  return Di(o, function(f) {
    e.on(f, n.emit.bind(n, f));
  }), n._read = function(f) {
    t && (t = !1, e.resume());
  }, n;
};
fe._fromList = Pt;
function Pt(e, r) {
  var t = r.buffer, n = r.length, i = !!r.decoder, o = !!r.objectMode, f;
  if (t.length === 0)
    return null;
  if (n === 0)
    f = null;
  else if (o)
    f = t.shift();
  else if (!e || e >= n)
    i ? f = t.join("") : f = Hr.concat(t, n), t.length = 0;
  else if (e < t[0].length) {
    var u = t[0];
    f = u.slice(0, e), t[0] = u.slice(e);
  } else if (e === t[0].length)
    f = t.shift();
  else {
    i ? f = "" : f = new Hr(e);
    for (var c = 0, g = 0, y = t.length; g < y && c < e; g++) {
      var u = t[0], p = Math.min(e - c, u.length);
      i ? f += u.slice(0, p) : u.copy(f, c, 0, p), p < u.length ? t[0] = u.slice(p) : t.shift(), c += p;
    }
  }
  return f;
}
function Nt(e) {
  var r = e._readableState;
  if (r.length > 0)
    throw new Error("endReadable called on non-empty stream");
  !r.endEmitted && r.calledRead && (r.ended = !0, j.nextTick(function() {
    !r.endEmitted && r.length === 0 && (r.endEmitted = !0, e.readable = !1, e.emit("end"));
  }));
}
function Di(e, r) {
  for (var t = 0, n = e.length; t < n; t++)
    r(e[t], t);
}
function Bo(e, r) {
  for (var t = 0, n = e.length; t < n; t++)
    if (e[t] === r)
      return t;
  return -1;
}
var _t, Wn;
function nn() {
  if (Wn)
    return _t;
  Wn = 1, _t = i;
  var e = Object.keys || function(u) {
    var c = [];
    for (var g in u)
      c.push(g);
    return c;
  }, r = ee;
  r.inherits = ue;
  var t = Ti, n = Oi();
  r.inherits(i, t), f(e(n.prototype), function(u) {
    i.prototype[u] || (i.prototype[u] = n.prototype[u]);
  });
  function i(u) {
    if (!(this instanceof i))
      return new i(u);
    t.call(this, u), n.call(this, u), u && u.readable === !1 && (this.readable = !1), u && u.writable === !1 && (this.writable = !1), this.allowHalfOpen = !0, u && u.allowHalfOpen === !1 && (this.allowHalfOpen = !1), this.once("end", o);
  }
  function o() {
    this.allowHalfOpen || this._writableState.ended || j.nextTick(this.end.bind(this));
  }
  function f(u, c) {
    for (var g = 0, y = u.length; g < y; g++)
      c(u[g], g);
  }
  return _t;
}
var St, Hn;
function Oi() {
  if (Hn)
    return St;
  Hn = 1, St = o;
  var e = ne.Buffer;
  o.WritableState = i;
  var r = ee;
  r.inherits = ue;
  var t = Ke;
  r.inherits(o, t);
  function n(_, w, C) {
    this.chunk = _, this.encoding = w, this.callback = C;
  }
  function i(_, w) {
    _ = _ || {};
    var C = _.highWaterMark;
    this.highWaterMark = C || C === 0 ? C : 16 * 1024, this.objectMode = !!_.objectMode, this.highWaterMark = ~~this.highWaterMark, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1;
    var F = _.decodeStrings === !1;
    this.decodeStrings = !F, this.defaultEncoding = _.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(B) {
      N(w, B);
    }, this.writecb = null, this.writelen = 0, this.buffer = [], this.errorEmitted = !1;
  }
  function o(_) {
    var w = nn();
    if (!(this instanceof o) && !(this instanceof w))
      return new o(_);
    this._writableState = new i(_, this), this.writable = !0, t.call(this);
  }
  o.prototype.pipe = function() {
    this.emit("error", new Error("Cannot pipe. Not readable."));
  };
  function f(_, w, C) {
    var F = new Error("write after end");
    _.emit("error", F), j.nextTick(function() {
      C(F);
    });
  }
  function u(_, w, C, F) {
    var B = !0;
    if (!e.isBuffer(C) && typeof C != "string" && C !== null && C !== void 0 && !w.objectMode) {
      var q = new TypeError("Invalid non-string/buffer chunk");
      _.emit("error", q), j.nextTick(function() {
        F(q);
      }), B = !1;
    }
    return B;
  }
  o.prototype.write = function(_, w, C) {
    var F = this._writableState, B = !1;
    return typeof w == "function" && (C = w, w = null), e.isBuffer(_) ? w = "buffer" : w || (w = F.defaultEncoding), typeof C != "function" && (C = function() {
    }), F.ended ? f(this, F, C) : u(this, F, _, C) && (B = g(this, F, _, w, C)), B;
  };
  function c(_, w, C) {
    return !_.objectMode && _.decodeStrings !== !1 && typeof w == "string" && (w = new e(w, C)), w;
  }
  function g(_, w, C, F, B) {
    C = c(w, C, F), e.isBuffer(C) && (F = "buffer");
    var q = w.objectMode ? 1 : C.length;
    w.length += q;
    var ae = w.length < w.highWaterMark;
    return ae || (w.needDrain = !0), w.writing ? w.buffer.push(new n(C, F, B)) : y(_, w, q, C, F, B), ae;
  }
  function y(_, w, C, F, B, q) {
    w.writelen = C, w.writecb = q, w.writing = !0, w.sync = !0, _._write(F, B, w.onwrite), w.sync = !1;
  }
  function p(_, w, C, F, B) {
    C ? j.nextTick(function() {
      B(F);
    }) : B(F), _._writableState.errorEmitted = !0, _.emit("error", F);
  }
  function R(_) {
    _.writing = !1, _.writecb = null, _.length -= _.writelen, _.writelen = 0;
  }
  function N(_, w) {
    var C = _._writableState, F = C.sync, B = C.writecb;
    if (R(C), w)
      p(_, C, F, w, B);
    else {
      var q = b(_, C);
      !q && !C.bufferProcessing && C.buffer.length && A(_, C), F ? j.nextTick(function() {
        D(_, C, q, B);
      }) : D(_, C, q, B);
    }
  }
  function D(_, w, C, F) {
    C || x(_, w), F(), C && m(_, w);
  }
  function x(_, w) {
    w.length === 0 && w.needDrain && (w.needDrain = !1, _.emit("drain"));
  }
  function A(_, w) {
    w.bufferProcessing = !0;
    for (var C = 0; C < w.buffer.length; C++) {
      var F = w.buffer[C], B = F.chunk, q = F.encoding, ae = F.callback, de = w.objectMode ? 1 : B.length;
      if (y(_, w, de, B, q, ae), w.writing) {
        C++;
        break;
      }
    }
    w.bufferProcessing = !1, C < w.buffer.length ? w.buffer = w.buffer.slice(C) : w.buffer.length = 0;
  }
  o.prototype._write = function(_, w, C) {
    C(new Error("not implemented"));
  }, o.prototype.end = function(_, w, C) {
    var F = this._writableState;
    typeof _ == "function" ? (C = _, _ = null, w = null) : typeof w == "function" && (C = w, w = null), typeof _ < "u" && _ !== null && this.write(_, w), !F.ending && !F.finished && O(this, F, C);
  };
  function b(_, w) {
    return w.ending && w.length === 0 && !w.finished && !w.writing;
  }
  function m(_, w) {
    var C = b(_, w);
    return C && (w.finished = !0, _.emit("finish")), C;
  }
  function O(_, w, C) {
    w.ending = !0, m(_, w), C && (w.finished ? j.nextTick(C) : _.once("finish", C)), w.ended = !0;
  }
  return St;
}
var Ai = He, an = nn(), Li = ee;
Li.inherits = ue;
Li.inherits(He, an);
function qo(e, r) {
  this.afterTransform = function(t, n) {
    return Wo(r, t, n);
  }, this.needTransform = !1, this.transforming = !1, this.writecb = null, this.writechunk = null;
}
function Wo(e, r, t) {
  var n = e._transformState;
  n.transforming = !1;
  var i = n.writecb;
  if (!i)
    return e.emit("error", new Error("no writecb in Transform class"));
  n.writechunk = null, n.writecb = null, t != null && e.push(t), i && i(r);
  var o = e._readableState;
  o.reading = !1, (o.needReadable || o.length < o.highWaterMark) && e._read(o.highWaterMark);
}
function He(e) {
  if (!(this instanceof He))
    return new He(e);
  an.call(this, e), this._transformState = new qo(e, this);
  var r = this;
  this._readableState.needReadable = !0, this._readableState.sync = !1, this.once("finish", function() {
    typeof this._flush == "function" ? this._flush(function(t) {
      $n(r, t);
    }) : $n(r);
  });
}
He.prototype.push = function(e, r) {
  return this._transformState.needTransform = !1, an.prototype.push.call(this, e, r);
};
He.prototype._transform = function(e, r, t) {
  throw new Error("not implemented");
};
He.prototype._write = function(e, r, t) {
  var n = this._transformState;
  if (n.writecb = t, n.writechunk = e, n.writeencoding = r, !n.transforming) {
    var i = this._readableState;
    (n.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
  }
};
He.prototype._read = function(e) {
  var r = this._transformState;
  r.writechunk !== null && r.writecb && !r.transforming ? (r.transforming = !0, this._transform(r.writechunk, r.writeencoding, r.afterTransform)) : r.needTransform = !0;
};
function $n(e, r) {
  if (r)
    return e.emit("error", r);
  var t = e._writableState;
  e._readableState;
  var n = e._transformState;
  if (t.length)
    throw new Error("calling transform done when ws.length != 0");
  if (n.transforming)
    throw new Error("calling transform done when still transforming");
  return e.push(null);
}
var Ho = xr, Pi = Ai, Ni = ee;
Ni.inherits = ue;
Ni.inherits(xr, Pi);
function xr(e) {
  if (!(this instanceof xr))
    return new xr(e);
  Pi.call(this, e);
}
xr.prototype._transform = function(e, r, t) {
  t(null, e);
};
(function(e, r) {
  var t = Ke;
  r = e.exports = Ti, r.Stream = t, r.Readable = r, r.Writable = Oi(), r.Duplex = nn(), r.Transform = Ai, r.PassThrough = Ho, !j.browser && j.env.READABLE_STREAM === "disable" && (e.exports = Ke);
})(At, At.exports);
var $o = At.exports, Ve = go, Fi = $o.Transform, Uo = ue;
Uo(Le, Fi);
var zo = Le, Me = {
  lt: "<".charCodeAt(0),
  gt: ">".charCodeAt(0),
  slash: "/".charCodeAt(0),
  dquote: '"'.charCodeAt(0),
  squote: "'".charCodeAt(0),
  equal: "=".charCodeAt(0)
}, Fe = {
  endScript: Ve("<\/script"),
  endStyle: Ve("</style"),
  endTitle: Ve("</title"),
  comment: Ve("<!--"),
  endComment: Ve("-->"),
  cdata: Ve("<![CDATA["),
  endCdata: Ve("]]>")
}, he = {
  TagNameState: 1,
  AttributeNameState: 2,
  BeforeAttributeValueState: 3,
  AttributeValueState: 4
};
function Le() {
  if (!(this instanceof Le))
    return new Le();
  Fi.call(this), this._readableState.objectMode = !0, this.state = "text", this.tagState = null, this.quoteState = null, this.raw = null, this.buffers = [], this._last = [];
}
Le.prototype._transform = function(e, r, t) {
  var n = 0, i = 0;
  for (this._prev && (e = ne.Buffer.concat([this._prev, e]), n = this._prev.length - 1, i = this._offset, this._prev = null, this._offset = 0); n < e.length; n++) {
    var o = e[n];
    if (this._last.push(o), this._last.length > 9 && this._last.shift(), this.raw) {
      var f = this._testRaw(e, i, n);
      f && (this.push(["text", f[0]]), this.raw === Fe.endComment || this.raw === Fe.endCdata ? (this.state = "text", this.buffers = [], this.push(["close", f[1]])) : (this.state = "open", this.buffers = [f[1]]), this.raw = null, i = n + 1);
    } else {
      if (this.state === "text" && o === Me.lt && n === e.length - 1)
        return this._prev = e, this._offset = i, t();
      if (this.state === "text" && o === Me.lt && !Ar(e[n + 1]))
        n > 0 && n - i > 0 && this.buffers.push(e.slice(i, n)), i = n, this.state = "open", this.tagState = he.TagNameState, this._pushState("text");
      else if (this.tagState === he.TagNameState && Ar(o))
        this.tagState = he.AttributeNameState;
      else if (this.tagState === he.AttributeNameState && o === Me.equal)
        this.tagState = he.BeforeAttributeValueState;
      else if (!(this.tagState === he.BeforeAttributeValueState && Ar(o)))
        if (this.tagState === he.BeforeAttributeValueState && o !== Me.gt)
          this.tagState = he.AttributeValueState, o === Me.dquote ? this.quoteState = "double" : o === Me.squote ? this.quoteState = "single" : this.quoteState = null;
        else if (this.tagState === he.AttributeValueState && !this.quoteState && Ar(o))
          this.tagState = he.AttributeNameState;
        else if (this.tagState === he.AttributeValueState && this.quoteState === "double" && o === Me.dquote)
          this.quoteState = null, this.tagState = he.AttributeNameState;
        else if (this.tagState === he.AttributeValueState && this.quoteState === "single" && o === Me.squote)
          this.quoteState = null, this.tagState = he.AttributeNameState;
        else if (this.state === "open" && o === Me.gt && !this.quoteState)
          if (this.buffers.push(e.slice(i, n + 1)), i = n + 1, this.state = "text", this.tagState = null, this._getChar(1) === Me.slash)
            this._pushState("close");
          else {
            var u = this._getTag();
            u === "script" && (this.raw = Fe.endScript), u === "style" && (this.raw = Fe.endStyle), u === "title" && (this.raw = Fe.endTitle), this._pushState("open");
          }
        else
          this.state === "open" && Ft(this._last, Fe.comment) ? (this.buffers.push(e.slice(i, n + 1)), i = n + 1, this.state = "text", this.raw = Fe.endComment, this._pushState("open")) : this.state === "open" && Ft(this._last, Fe.cdata) && (this.buffers.push(e.slice(i, n + 1)), i = n + 1, this.state = "text", this.raw = Fe.endCdata, this._pushState("open"));
    }
  }
  i < e.length && this.buffers.push(e.slice(i)), t();
};
Le.prototype._flush = function(e) {
  this.state === "text" && this._pushState("text"), this.push(null), e();
};
Le.prototype._pushState = function(e) {
  if (this.buffers.length !== 0) {
    var r = ne.Buffer.concat(this.buffers);
    this.buffers = [], this.push([e, r]);
  }
};
Le.prototype._getChar = function(e) {
  for (var r = 0, t = 0; t < this.buffers.length; t++) {
    var n = this.buffers[t];
    if (r + n.length > e)
      return n[e - r];
    r += n;
  }
};
Le.prototype._getTag = function() {
  for (var e = 0, r = "", t = 0; t < this.buffers.length; t++) {
    for (var n = this.buffers[t], i = 0; i < n.length; i++)
      if (!(e === 0 && i === 0)) {
        var o = String.fromCharCode(n[i]);
        if (/[^\w-!\[\]]/.test(o))
          return r.toLowerCase();
        r += o;
      }
    e += n.length;
  }
};
Le.prototype._testRaw = function(o, r, t) {
  var n = this.raw, i = this._last;
  if (Ft(i, n)) {
    this.buffers.push(o.slice(r, t + 1));
    var o = ne.Buffer.concat(this.buffers), f = o.length - n.length;
    return [o.slice(0, f), o.slice(f)];
  }
};
function Ft(e, r) {
  if (e.length < r.length)
    return !1;
  for (var t = e.length - 1, n = r.length - 1; t >= 0 && n >= 0; t--, n--)
    if (Un(e[t]) !== Un(r[n]))
      return !1;
  return !0;
}
function Un(e) {
  return e >= 65 && e <= 90 ? e + 32 : e;
}
function Ar(e) {
  return e === 32 || e === 9 || e === 10 || e === 12 || e === 13;
}
const Go = /* @__PURE__ */ Gt(zo);
var on = { exports: {} }, jt = { exports: {} }, It = { exports: {} };
typeof j > "u" || !j.version || j.version.indexOf("v0.") === 0 || j.version.indexOf("v1.") === 0 && j.version.indexOf("v1.8.") !== 0 ? It.exports = { nextTick: Vo } : It.exports = j;
function Vo(e, r, t, n) {
  if (typeof e != "function")
    throw new TypeError('"callback" argument must be a function');
  var i = arguments.length, o, f;
  switch (i) {
    case 0:
    case 1:
      return j.nextTick(e);
    case 2:
      return j.nextTick(function() {
        e.call(null, r);
      });
    case 3:
      return j.nextTick(function() {
        e.call(null, r, t);
      });
    case 4:
      return j.nextTick(function() {
        e.call(null, r, t, n);
      });
    default:
      for (o = new Array(i - 1), f = 0; f < o.length; )
        o[f++] = arguments[f];
      return j.nextTick(function() {
        e.apply(null, o);
      });
  }
}
var et = It.exports, Yo = {}.toString, Ko = Array.isArray || function(e) {
  return Yo.call(e) == "[object Array]";
}, ji = pr.EventEmitter, Bt = { exports: {} };
(function(e, r) {
  var t = ne, n = t.Buffer;
  function i(f, u) {
    for (var c in f)
      u[c] = f[c];
  }
  n.from && n.alloc && n.allocUnsafe && n.allocUnsafeSlow ? e.exports = t : (i(t, r), r.Buffer = o);
  function o(f, u, c) {
    return n(f, u, c);
  }
  i(n, o), o.from = function(f, u, c) {
    if (typeof f == "number")
      throw new TypeError("Argument must not be a number");
    return n(f, u, c);
  }, o.alloc = function(f, u, c) {
    if (typeof f != "number")
      throw new TypeError("Argument must be a number");
    var g = n(f);
    return u !== void 0 ? typeof c == "string" ? g.fill(u, c) : g.fill(u) : g.fill(0), g;
  }, o.allocUnsafe = function(f) {
    if (typeof f != "number")
      throw new TypeError("Argument must be a number");
    return n(f);
  }, o.allocUnsafeSlow = function(f) {
    if (typeof f != "number")
      throw new TypeError("Argument must be a number");
    return t.SlowBuffer(f);
  };
})(Bt, Bt.exports);
var fn = Bt.exports, Et = { exports: {} }, zn;
function Xo() {
  return zn || (zn = 1, function(e) {
    function r(o, f) {
      if (!(o instanceof f))
        throw new TypeError("Cannot call a class as a function");
    }
    var t = fn.Buffer, n = Gr;
    function i(o, f, u) {
      o.copy(f, u);
    }
    e.exports = function() {
      function o() {
        r(this, o), this.head = null, this.tail = null, this.length = 0;
      }
      return o.prototype.push = function(u) {
        var c = { data: u, next: null };
        this.length > 0 ? this.tail.next = c : this.head = c, this.tail = c, ++this.length;
      }, o.prototype.unshift = function(u) {
        var c = { data: u, next: this.head };
        this.length === 0 && (this.tail = c), this.head = c, ++this.length;
      }, o.prototype.shift = function() {
        if (this.length !== 0) {
          var u = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, u;
        }
      }, o.prototype.clear = function() {
        this.head = this.tail = null, this.length = 0;
      }, o.prototype.join = function(u) {
        if (this.length === 0)
          return "";
        for (var c = this.head, g = "" + c.data; c = c.next; )
          g += u + c.data;
        return g;
      }, o.prototype.concat = function(u) {
        if (this.length === 0)
          return t.alloc(0);
        for (var c = t.allocUnsafe(u >>> 0), g = this.head, y = 0; g; )
          i(g.data, c, y), y += g.data.length, g = g.next;
        return c;
      }, o;
    }(), n && n.inspect && n.inspect.custom && (e.exports.prototype[n.inspect.custom] = function() {
      var o = n.inspect({ length: this.length });
      return this.constructor.name + " " + o;
    });
  }(Et)), Et.exports;
}
var Lr = et;
function Zo(e, r) {
  var t = this, n = this._readableState && this._readableState.destroyed, i = this._writableState && this._writableState.destroyed;
  return n || i ? (r ? r(e) : e && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, Lr.nextTick(Pr, this, e)) : Lr.nextTick(Pr, this, e)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(e || null, function(o) {
    !r && o ? t._writableState ? t._writableState.errorEmitted || (t._writableState.errorEmitted = !0, Lr.nextTick(Pr, t, o)) : Lr.nextTick(Pr, t, o) : r && r(o);
  }), this);
}
function Jo() {
  this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
}
function Pr(e, r) {
  e.emit("error", r);
}
var Ii = {
  destroy: Zo,
  undestroy: Jo
}, Rt, Gn;
function Bi() {
  if (Gn)
    return Rt;
  Gn = 1;
  var e = et;
  Rt = x;
  function r(E) {
    var k = this;
    this.next = null, this.entry = null, this.finish = function() {
      ze(k, E);
    };
  }
  var t = !j.browser && ["v0.10", "v0.9."].indexOf(j.version.slice(0, 5)) > -1 ? setImmediate : e.nextTick, n;
  x.WritableState = N;
  var i = Object.create(ee);
  i.inherits = ue;
  var o = {
    deprecate: Si()
  }, f = ji, u = fn.Buffer, c = (typeof Ae < "u" ? Ae : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function g(E) {
    return u.from(E);
  }
  function y(E) {
    return u.isBuffer(E) || E instanceof c;
  }
  var p = Ii;
  i.inherits(x, f);
  function R() {
  }
  function N(E, k) {
    n = n || lr(), E = E || {};
    var P = k instanceof n;
    this.objectMode = !!E.objectMode, P && (this.objectMode = this.objectMode || !!E.writableObjectMode);
    var H = E.highWaterMark, U = E.writableHighWaterMark, z = this.objectMode ? 16 : 16 * 1024;
    H || H === 0 ? this.highWaterMark = H : P && (U || U === 0) ? this.highWaterMark = U : this.highWaterMark = z, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var oe = E.decodeStrings === !1;
    this.decodeStrings = !oe, this.defaultEncoding = E.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(ce) {
      F(k, ce);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new r(this);
  }
  N.prototype.getBuffer = function() {
    for (var k = this.bufferedRequest, P = []; k; )
      P.push(k), k = k.next;
    return P;
  }, function() {
    try {
      Object.defineProperty(N.prototype, "buffer", {
        get: o.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var D;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (D = Function.prototype[Symbol.hasInstance], Object.defineProperty(x, Symbol.hasInstance, {
    value: function(E) {
      return D.call(this, E) ? !0 : this !== x ? !1 : E && E._writableState instanceof N;
    }
  })) : D = function(E) {
    return E instanceof this;
  };
  function x(E) {
    if (n = n || lr(), !D.call(x, this) && !(this instanceof n))
      return new x(E);
    this._writableState = new N(E, this), this.writable = !0, E && (typeof E.write == "function" && (this._write = E.write), typeof E.writev == "function" && (this._writev = E.writev), typeof E.destroy == "function" && (this._destroy = E.destroy), typeof E.final == "function" && (this._final = E.final)), f.call(this);
  }
  x.prototype.pipe = function() {
    this.emit("error", new Error("Cannot pipe, not readable"));
  };
  function A(E, k) {
    var P = new Error("write after end");
    E.emit("error", P), e.nextTick(k, P);
  }
  function b(E, k, P, H) {
    var U = !0, z = !1;
    return P === null ? z = new TypeError("May not write null values to stream") : typeof P != "string" && P !== void 0 && !k.objectMode && (z = new TypeError("Invalid non-string/buffer chunk")), z && (E.emit("error", z), e.nextTick(H, z), U = !1), U;
  }
  x.prototype.write = function(E, k, P) {
    var H = this._writableState, U = !1, z = !H.objectMode && y(E);
    return z && !u.isBuffer(E) && (E = g(E)), typeof k == "function" && (P = k, k = null), z ? k = "buffer" : k || (k = H.defaultEncoding), typeof P != "function" && (P = R), H.ended ? A(this, P) : (z || b(this, H, E, P)) && (H.pendingcb++, U = O(this, H, z, E, k, P)), U;
  }, x.prototype.cork = function() {
    var E = this._writableState;
    E.corked++;
  }, x.prototype.uncork = function() {
    var E = this._writableState;
    E.corked && (E.corked--, !E.writing && !E.corked && !E.bufferProcessing && E.bufferedRequest && ae(this, E));
  }, x.prototype.setDefaultEncoding = function(k) {
    if (typeof k == "string" && (k = k.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((k + "").toLowerCase()) > -1))
      throw new TypeError("Unknown encoding: " + k);
    return this._writableState.defaultEncoding = k, this;
  };
  function m(E, k, P) {
    return !E.objectMode && E.decodeStrings !== !1 && typeof k == "string" && (k = u.from(k, P)), k;
  }
  Object.defineProperty(x.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function O(E, k, P, H, U, z) {
    if (!P) {
      var oe = m(k, H, U);
      H !== oe && (P = !0, U = "buffer", H = oe);
    }
    var ce = k.objectMode ? 1 : H.length;
    k.length += ce;
    var _e = k.length < k.highWaterMark;
    if (_e || (k.needDrain = !0), k.writing || k.corked) {
      var S = k.lastBufferedRequest;
      k.lastBufferedRequest = {
        chunk: H,
        encoding: U,
        isBuf: P,
        callback: z,
        next: null
      }, S ? S.next = k.lastBufferedRequest : k.bufferedRequest = k.lastBufferedRequest, k.bufferedRequestCount += 1;
    } else
      _(E, k, !1, ce, H, U, z);
    return _e;
  }
  function _(E, k, P, H, U, z, oe) {
    k.writelen = H, k.writecb = oe, k.writing = !0, k.sync = !0, P ? E._writev(U, k.onwrite) : E._write(U, z, k.onwrite), k.sync = !1;
  }
  function w(E, k, P, H, U) {
    --k.pendingcb, P ? (e.nextTick(U, H), e.nextTick(we, E, k), E._writableState.errorEmitted = !0, E.emit("error", H)) : (U(H), E._writableState.errorEmitted = !0, E.emit("error", H), we(E, k));
  }
  function C(E) {
    E.writing = !1, E.writecb = null, E.length -= E.writelen, E.writelen = 0;
  }
  function F(E, k) {
    var P = E._writableState, H = P.sync, U = P.writecb;
    if (C(P), k)
      w(E, P, H, k, U);
    else {
      var z = de(P);
      !z && !P.corked && !P.bufferProcessing && P.bufferedRequest && ae(E, P), H ? t(B, E, P, z, U) : B(E, P, z, U);
    }
  }
  function B(E, k, P, H) {
    P || q(E, k), k.pendingcb--, H(), we(E, k);
  }
  function q(E, k) {
    k.length === 0 && k.needDrain && (k.needDrain = !1, E.emit("drain"));
  }
  function ae(E, k) {
    k.bufferProcessing = !0;
    var P = k.bufferedRequest;
    if (E._writev && P && P.next) {
      var H = k.bufferedRequestCount, U = new Array(H), z = k.corkedRequestsFree;
      z.entry = P;
      for (var oe = 0, ce = !0; P; )
        U[oe] = P, P.isBuf || (ce = !1), P = P.next, oe += 1;
      U.allBuffers = ce, _(E, k, !0, k.length, U, "", z.finish), k.pendingcb++, k.lastBufferedRequest = null, z.next ? (k.corkedRequestsFree = z.next, z.next = null) : k.corkedRequestsFree = new r(k), k.bufferedRequestCount = 0;
    } else {
      for (; P; ) {
        var _e = P.chunk, S = P.encoding, a = P.callback, s = k.objectMode ? 1 : _e.length;
        if (_(E, k, !1, s, _e, S, a), P = P.next, k.bufferedRequestCount--, k.writing)
          break;
      }
      P === null && (k.lastBufferedRequest = null);
    }
    k.bufferedRequest = P, k.bufferProcessing = !1;
  }
  x.prototype._write = function(E, k, P) {
    P(new Error("_write() is not implemented"));
  }, x.prototype._writev = null, x.prototype.end = function(E, k, P) {
    var H = this._writableState;
    typeof E == "function" ? (P = E, E = null, k = null) : typeof k == "function" && (P = k, k = null), E != null && this.write(E, k), H.corked && (H.corked = 1, this.uncork()), H.ending || Be(this, H, P);
  };
  function de(E) {
    return E.ending && E.length === 0 && E.bufferedRequest === null && !E.finished && !E.writing;
  }
  function Ie(E, k) {
    E._final(function(P) {
      k.pendingcb--, P && E.emit("error", P), k.prefinished = !0, E.emit("prefinish"), we(E, k);
    });
  }
  function me(E, k) {
    !k.prefinished && !k.finalCalled && (typeof E._final == "function" ? (k.pendingcb++, k.finalCalled = !0, e.nextTick(Ie, E, k)) : (k.prefinished = !0, E.emit("prefinish")));
  }
  function we(E, k) {
    var P = de(k);
    return P && (me(E, k), k.pendingcb === 0 && (k.finished = !0, E.emit("finish"))), P;
  }
  function Be(E, k, P) {
    k.ending = !0, we(E, k), P && (k.finished ? e.nextTick(P) : E.once("finish", P)), k.ended = !0, E.writable = !1;
  }
  function ze(E, k, P) {
    var H = E.entry;
    for (E.entry = null; H; ) {
      var U = H.callback;
      k.pendingcb--, U(P), H = H.next;
    }
    k.corkedRequestsFree.next = E;
  }
  return Object.defineProperty(x.prototype, "destroyed", {
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(E) {
      this._writableState && (this._writableState.destroyed = E);
    }
  }), x.prototype.destroy = p.destroy, x.prototype._undestroy = p.undestroy, x.prototype._destroy = function(E, k) {
    this.end(), k(E);
  }, Rt;
}
var xt, Vn;
function lr() {
  if (Vn)
    return xt;
  Vn = 1;
  var e = et, r = Object.keys || function(p) {
    var R = [];
    for (var N in p)
      R.push(N);
    return R;
  };
  xt = c;
  var t = Object.create(ee);
  t.inherits = ue;
  var n = qi(), i = Bi();
  t.inherits(c, n);
  for (var o = r(i.prototype), f = 0; f < o.length; f++) {
    var u = o[f];
    c.prototype[u] || (c.prototype[u] = i.prototype[u]);
  }
  function c(p) {
    if (!(this instanceof c))
      return new c(p);
    n.call(this, p), i.call(this, p), p && p.readable === !1 && (this.readable = !1), p && p.writable === !1 && (this.writable = !1), this.allowHalfOpen = !0, p && p.allowHalfOpen === !1 && (this.allowHalfOpen = !1), this.once("end", g);
  }
  Object.defineProperty(c.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function g() {
    this.allowHalfOpen || this._writableState.ended || e.nextTick(y, this);
  }
  function y(p) {
    p.end();
  }
  return Object.defineProperty(c.prototype, "destroyed", {
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(p) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = p, this._writableState.destroyed = p);
    }
  }), c.prototype._destroy = function(p, R) {
    this.push(null), this.end(), e.nextTick(R, p);
  }, xt;
}
var Tt, Yn;
function qi() {
  if (Yn)
    return Tt;
  Yn = 1;
  var e = et;
  Tt = m;
  var r = Ko, t;
  m.ReadableState = b, pr.EventEmitter;
  var n = function(a, s) {
    return a.listeners(s).length;
  }, i = ji, o = fn.Buffer, f = (typeof Ae < "u" ? Ae : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function u(a) {
    return o.from(a);
  }
  function c(a) {
    return o.isBuffer(a) || a instanceof f;
  }
  var g = Object.create(ee);
  g.inherits = ue;
  var y = Gr, p = void 0;
  y && y.debuglog ? p = y.debuglog("stream") : p = function() {
  };
  var R = Xo(), N = Ii, D;
  g.inherits(m, i);
  var x = ["error", "close", "destroy", "pause", "resume"];
  function A(a, s, T) {
    if (typeof a.prependListener == "function")
      return a.prependListener(s, T);
    !a._events || !a._events[s] ? a.on(s, T) : r(a._events[s]) ? a._events[s].unshift(T) : a._events[s] = [T, a._events[s]];
  }
  function b(a, s) {
    t = t || lr(), a = a || {};
    var T = s instanceof t;
    this.objectMode = !!a.objectMode, T && (this.objectMode = this.objectMode || !!a.readableObjectMode);
    var L = a.highWaterMark, d = a.readableHighWaterMark, l = this.objectMode ? 16 : 16 * 1024;
    L || L === 0 ? this.highWaterMark = L : T && (d || d === 0) ? this.highWaterMark = d : this.highWaterMark = l, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new R(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = a.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, a.encoding && (D || (D = ur().StringDecoder), this.decoder = new D(a.encoding), this.encoding = a.encoding);
  }
  function m(a) {
    if (t = t || lr(), !(this instanceof m))
      return new m(a);
    this._readableState = new b(a, this), this.readable = !0, a && (typeof a.read == "function" && (this._read = a.read), typeof a.destroy == "function" && (this._destroy = a.destroy)), i.call(this);
  }
  Object.defineProperty(m.prototype, "destroyed", {
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(a) {
      this._readableState && (this._readableState.destroyed = a);
    }
  }), m.prototype.destroy = N.destroy, m.prototype._undestroy = N.undestroy, m.prototype._destroy = function(a, s) {
    this.push(null), s(a);
  }, m.prototype.push = function(a, s) {
    var T = this._readableState, L;
    return T.objectMode ? L = !0 : typeof a == "string" && (s = s || T.defaultEncoding, s !== T.encoding && (a = o.from(a, s), s = ""), L = !0), O(this, a, s, !1, L);
  }, m.prototype.unshift = function(a) {
    return O(this, a, null, !0, !1);
  };
  function O(a, s, T, L, d) {
    var l = a._readableState;
    if (s === null)
      l.reading = !1, ae(a, l);
    else {
      var M;
      d || (M = w(l, s)), M ? a.emit("error", M) : l.objectMode || s && s.length > 0 ? (typeof s != "string" && !l.objectMode && Object.getPrototypeOf(s) !== o.prototype && (s = u(s)), L ? l.endEmitted ? a.emit("error", new Error("stream.unshift() after end event")) : _(a, l, s, !0) : l.ended ? a.emit("error", new Error("stream.push() after EOF")) : (l.reading = !1, l.decoder && !T ? (s = l.decoder.write(s), l.objectMode || s.length !== 0 ? _(a, l, s, !1) : me(a, l)) : _(a, l, s, !1))) : L || (l.reading = !1);
    }
    return C(l);
  }
  function _(a, s, T, L) {
    s.flowing && s.length === 0 && !s.sync ? (a.emit("data", T), a.read(0)) : (s.length += s.objectMode ? 1 : T.length, L ? s.buffer.unshift(T) : s.buffer.push(T), s.needReadable && de(a)), me(a, s);
  }
  function w(a, s) {
    var T;
    return !c(s) && typeof s != "string" && s !== void 0 && !a.objectMode && (T = new TypeError("Invalid non-string/buffer chunk")), T;
  }
  function C(a) {
    return !a.ended && (a.needReadable || a.length < a.highWaterMark || a.length === 0);
  }
  m.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, m.prototype.setEncoding = function(a) {
    return D || (D = ur().StringDecoder), this._readableState.decoder = new D(a), this._readableState.encoding = a, this;
  };
  var F = 8388608;
  function B(a) {
    return a >= F ? a = F : (a--, a |= a >>> 1, a |= a >>> 2, a |= a >>> 4, a |= a >>> 8, a |= a >>> 16, a++), a;
  }
  function q(a, s) {
    return a <= 0 || s.length === 0 && s.ended ? 0 : s.objectMode ? 1 : a !== a ? s.flowing && s.length ? s.buffer.head.data.length : s.length : (a > s.highWaterMark && (s.highWaterMark = B(a)), a <= s.length ? a : s.ended ? s.length : (s.needReadable = !0, 0));
  }
  m.prototype.read = function(a) {
    p("read", a), a = parseInt(a, 10);
    var s = this._readableState, T = a;
    if (a !== 0 && (s.emittedReadable = !1), a === 0 && s.needReadable && (s.length >= s.highWaterMark || s.ended))
      return p("read: emitReadable", s.length, s.ended), s.length === 0 && s.ended ? ce(this) : de(this), null;
    if (a = q(a, s), a === 0 && s.ended)
      return s.length === 0 && ce(this), null;
    var L = s.needReadable;
    p("need readable", L), (s.length === 0 || s.length - a < s.highWaterMark) && (L = !0, p("length less than watermark", L)), s.ended || s.reading ? (L = !1, p("reading or ended", L)) : L && (p("do read"), s.reading = !0, s.sync = !0, s.length === 0 && (s.needReadable = !0), this._read(s.highWaterMark), s.sync = !1, s.reading || (a = q(T, s)));
    var d;
    return a > 0 ? d = H(a, s) : d = null, d === null ? (s.needReadable = !0, a = 0) : s.length -= a, s.length === 0 && (s.ended || (s.needReadable = !0), T !== a && s.ended && ce(this)), d !== null && this.emit("data", d), d;
  };
  function ae(a, s) {
    if (!s.ended) {
      if (s.decoder) {
        var T = s.decoder.end();
        T && T.length && (s.buffer.push(T), s.length += s.objectMode ? 1 : T.length);
      }
      s.ended = !0, de(a);
    }
  }
  function de(a) {
    var s = a._readableState;
    s.needReadable = !1, s.emittedReadable || (p("emitReadable", s.flowing), s.emittedReadable = !0, s.sync ? e.nextTick(Ie, a) : Ie(a));
  }
  function Ie(a) {
    p("emit readable"), a.emit("readable"), P(a);
  }
  function me(a, s) {
    s.readingMore || (s.readingMore = !0, e.nextTick(we, a, s));
  }
  function we(a, s) {
    for (var T = s.length; !s.reading && !s.flowing && !s.ended && s.length < s.highWaterMark && (p("maybeReadMore read 0"), a.read(0), T !== s.length); )
      T = s.length;
    s.readingMore = !1;
  }
  m.prototype._read = function(a) {
    this.emit("error", new Error("_read() is not implemented"));
  }, m.prototype.pipe = function(a, s) {
    var T = this, L = this._readableState;
    switch (L.pipesCount) {
      case 0:
        L.pipes = a;
        break;
      case 1:
        L.pipes = [L.pipes, a];
        break;
      default:
        L.pipes.push(a);
        break;
    }
    L.pipesCount += 1, p("pipe count=%d opts=%j", L.pipesCount, s);
    var d = (!s || s.end !== !1) && a !== j.stdout && a !== j.stderr, l = d ? I : Pe;
    L.endEmitted ? e.nextTick(l) : T.once("end", l), a.on("unpipe", M);
    function M(ke, Ne) {
      p("onunpipe"), ke === T && Ne && Ne.hasUnpiped === !1 && (Ne.hasUnpiped = !0, K());
    }
    function I() {
      p("onend"), a.end();
    }
    var Q = Be(T);
    a.on("drain", Q);
    var $ = !1;
    function K() {
      p("cleanup"), a.removeListener("close", vr), a.removeListener("finish", Ze), a.removeListener("drain", Q), a.removeListener("error", Xe), a.removeListener("unpipe", M), T.removeListener("end", I), T.removeListener("end", Pe), T.removeListener("data", Ge), $ = !0, L.awaitDrain && (!a._writableState || a._writableState.needDrain) && Q();
    }
    var Te = !1;
    T.on("data", Ge);
    function Ge(ke) {
      p("ondata"), Te = !1;
      var Ne = a.write(ke);
      Ne === !1 && !Te && ((L.pipesCount === 1 && L.pipes === a || L.pipesCount > 1 && S(L.pipes, a) !== -1) && !$ && (p("false write response, pause", L.awaitDrain), L.awaitDrain++, Te = !0), T.pause());
    }
    function Xe(ke) {
      p("onerror", ke), Pe(), a.removeListener("error", Xe), n(a, "error") === 0 && a.emit("error", ke);
    }
    A(a, "error", Xe);
    function vr() {
      a.removeListener("finish", Ze), Pe();
    }
    a.once("close", vr);
    function Ze() {
      p("onfinish"), a.removeListener("close", vr), Pe();
    }
    a.once("finish", Ze);
    function Pe() {
      p("unpipe"), T.unpipe(a);
    }
    return a.emit("pipe", T), L.flowing || (p("pipe resume"), T.resume()), a;
  };
  function Be(a) {
    return function() {
      var s = a._readableState;
      p("pipeOnDrain", s.awaitDrain), s.awaitDrain && s.awaitDrain--, s.awaitDrain === 0 && n(a, "data") && (s.flowing = !0, P(a));
    };
  }
  m.prototype.unpipe = function(a) {
    var s = this._readableState, T = { hasUnpiped: !1 };
    if (s.pipesCount === 0)
      return this;
    if (s.pipesCount === 1)
      return a && a !== s.pipes ? this : (a || (a = s.pipes), s.pipes = null, s.pipesCount = 0, s.flowing = !1, a && a.emit("unpipe", this, T), this);
    if (!a) {
      var L = s.pipes, d = s.pipesCount;
      s.pipes = null, s.pipesCount = 0, s.flowing = !1;
      for (var l = 0; l < d; l++)
        L[l].emit("unpipe", this, { hasUnpiped: !1 });
      return this;
    }
    var M = S(s.pipes, a);
    return M === -1 ? this : (s.pipes.splice(M, 1), s.pipesCount -= 1, s.pipesCount === 1 && (s.pipes = s.pipes[0]), a.emit("unpipe", this, T), this);
  }, m.prototype.on = function(a, s) {
    var T = i.prototype.on.call(this, a, s);
    if (a === "data")
      this._readableState.flowing !== !1 && this.resume();
    else if (a === "readable") {
      var L = this._readableState;
      !L.endEmitted && !L.readableListening && (L.readableListening = L.needReadable = !0, L.emittedReadable = !1, L.reading ? L.length && de(this) : e.nextTick(ze, this));
    }
    return T;
  }, m.prototype.addListener = m.prototype.on;
  function ze(a) {
    p("readable nexttick read 0"), a.read(0);
  }
  m.prototype.resume = function() {
    var a = this._readableState;
    return a.flowing || (p("resume"), a.flowing = !0, E(this, a)), this;
  };
  function E(a, s) {
    s.resumeScheduled || (s.resumeScheduled = !0, e.nextTick(k, a, s));
  }
  function k(a, s) {
    s.reading || (p("resume read 0"), a.read(0)), s.resumeScheduled = !1, s.awaitDrain = 0, a.emit("resume"), P(a), s.flowing && !s.reading && a.read(0);
  }
  m.prototype.pause = function() {
    return p("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (p("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
  };
  function P(a) {
    var s = a._readableState;
    for (p("flow", s.flowing); s.flowing && a.read() !== null; )
      ;
  }
  m.prototype.wrap = function(a) {
    var s = this, T = this._readableState, L = !1;
    a.on("end", function() {
      if (p("wrapped end"), T.decoder && !T.ended) {
        var M = T.decoder.end();
        M && M.length && s.push(M);
      }
      s.push(null);
    }), a.on("data", function(M) {
      if (p("wrapped data"), T.decoder && (M = T.decoder.write(M)), !(T.objectMode && M == null) && !(!T.objectMode && (!M || !M.length))) {
        var I = s.push(M);
        I || (L = !0, a.pause());
      }
    });
    for (var d in a)
      this[d] === void 0 && typeof a[d] == "function" && (this[d] = function(M) {
        return function() {
          return a[M].apply(a, arguments);
        };
      }(d));
    for (var l = 0; l < x.length; l++)
      a.on(x[l], this.emit.bind(this, x[l]));
    return this._read = function(M) {
      p("wrapped _read", M), L && (L = !1, a.resume());
    }, this;
  }, Object.defineProperty(m.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), m._fromList = H;
  function H(a, s) {
    if (s.length === 0)
      return null;
    var T;
    return s.objectMode ? T = s.buffer.shift() : !a || a >= s.length ? (s.decoder ? T = s.buffer.join("") : s.buffer.length === 1 ? T = s.buffer.head.data : T = s.buffer.concat(s.length), s.buffer.clear()) : T = U(a, s.buffer, s.decoder), T;
  }
  function U(a, s, T) {
    var L;
    return a < s.head.data.length ? (L = s.head.data.slice(0, a), s.head.data = s.head.data.slice(a)) : a === s.head.data.length ? L = s.shift() : L = T ? z(a, s) : oe(a, s), L;
  }
  function z(a, s) {
    var T = s.head, L = 1, d = T.data;
    for (a -= d.length; T = T.next; ) {
      var l = T.data, M = a > l.length ? l.length : a;
      if (M === l.length ? d += l : d += l.slice(0, a), a -= M, a === 0) {
        M === l.length ? (++L, T.next ? s.head = T.next : s.head = s.tail = null) : (s.head = T, T.data = l.slice(M));
        break;
      }
      ++L;
    }
    return s.length -= L, d;
  }
  function oe(a, s) {
    var T = o.allocUnsafe(a), L = s.head, d = 1;
    for (L.data.copy(T), a -= L.data.length; L = L.next; ) {
      var l = L.data, M = a > l.length ? l.length : a;
      if (l.copy(T, T.length - a, 0, M), a -= M, a === 0) {
        M === l.length ? (++d, L.next ? s.head = L.next : s.head = s.tail = null) : (s.head = L, L.data = l.slice(M));
        break;
      }
      ++d;
    }
    return s.length -= d, T;
  }
  function ce(a) {
    var s = a._readableState;
    if (s.length > 0)
      throw new Error('"endReadable()" called on non-empty stream');
    s.endEmitted || (s.ended = !0, e.nextTick(_e, s, a));
  }
  function _e(a, s) {
    !a.endEmitted && a.length === 0 && (a.endEmitted = !0, s.readable = !1, s.emit("end"));
  }
  function S(a, s) {
    for (var T = 0, L = a.length; T < L; T++)
      if (a[T] === s)
        return T;
    return -1;
  }
  return Tt;
}
var Wi = je, rt = lr(), Hi = Object.create(ee);
Hi.inherits = ue;
Hi.inherits(je, rt);
function Qo(e, r) {
  var t = this._transformState;
  t.transforming = !1;
  var n = t.writecb;
  if (!n)
    return this.emit("error", new Error("write callback called multiple times"));
  t.writechunk = null, t.writecb = null, r != null && this.push(r), n(e);
  var i = this._readableState;
  i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
}
function je(e) {
  if (!(this instanceof je))
    return new je(e);
  rt.call(this, e), this._transformState = {
    afterTransform: Qo.bind(this),
    needTransform: !1,
    transforming: !1,
    writecb: null,
    writechunk: null,
    writeencoding: null
  }, this._readableState.needReadable = !0, this._readableState.sync = !1, e && (typeof e.transform == "function" && (this._transform = e.transform), typeof e.flush == "function" && (this._flush = e.flush)), this.on("prefinish", ef);
}
function ef() {
  var e = this;
  typeof this._flush == "function" ? this._flush(function(r, t) {
    Kn(e, r, t);
  }) : Kn(this, null, null);
}
je.prototype.push = function(e, r) {
  return this._transformState.needTransform = !1, rt.prototype.push.call(this, e, r);
};
je.prototype._transform = function(e, r, t) {
  throw new Error("_transform() is not implemented");
};
je.prototype._write = function(e, r, t) {
  var n = this._transformState;
  if (n.writecb = t, n.writechunk = e, n.writeencoding = r, !n.transforming) {
    var i = this._readableState;
    (n.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
  }
};
je.prototype._read = function(e) {
  var r = this._transformState;
  r.writechunk !== null && r.writecb && !r.transforming ? (r.transforming = !0, this._transform(r.writechunk, r.writeencoding, r.afterTransform)) : r.needTransform = !0;
};
je.prototype._destroy = function(e, r) {
  var t = this;
  rt.prototype._destroy.call(this, e, function(n) {
    r(n), t.emit("close");
  });
};
function Kn(e, r, t) {
  if (r)
    return e.emit("error", r);
  if (t != null && e.push(t), e._writableState.length)
    throw new Error("Calling transform done when ws.length != 0");
  if (e._transformState.transforming)
    throw new Error("Calling transform done when still transforming");
  return e.push(null);
}
var rf = Tr, $i = Wi, Ui = Object.create(ee);
Ui.inherits = ue;
Ui.inherits(Tr, $i);
function Tr(e) {
  if (!(this instanceof Tr))
    return new Tr(e);
  $i.call(this, e);
}
Tr.prototype._transform = function(e, r, t) {
  t(null, e);
};
(function(e, r) {
  r = e.exports = qi(), r.Stream = r, r.Readable = r, r.Writable = Bi(), r.Duplex = lr(), r.Transform = Wi, r.PassThrough = rf;
})(jt, jt.exports);
var tf = jt.exports, qt = tf;
function dr(e, r, t) {
  typeof t > "u" && (t = r, r = e, e = null), qt.Duplex.call(this, e), typeof t.read != "function" && (t = new qt.Readable(e).wrap(t)), this._writable = r, this._readable = t, this._waiting = !1;
  var n = this;
  r.once("finish", function() {
    n.end();
  }), this.once("finish", function() {
    r.end();
  }), t.on("readable", function() {
    n._waiting && (n._waiting = !1, n._read());
  }), t.once("end", function() {
    n.push(null);
  }), (!e || typeof e.bubbleErrors > "u" || e.bubbleErrors) && (r.on("error", function(i) {
    n.emit("error", i);
  }), t.on("error", function(i) {
    n.emit("error", i);
  }));
}
dr.prototype = Object.create(qt.Duplex.prototype, { constructor: { value: dr } });
dr.prototype._write = function(r, t, n) {
  this._writable.write(r, t, n);
};
dr.prototype._read = function() {
  for (var r, t = 0; (r = this._readable.read()) !== null; )
    this.push(r), t++;
  t === 0 && (this._waiting = !0);
};
on.exports = function(r, t, n) {
  return new dr(r, t, n);
};
on.exports.DuplexWrapper = dr;
var nf = on.exports, af = nf, Xn = Ke.PassThrough, of = Ke.PassThrough, ff = Xi, sf = [].slice, uf = {
  bubbleErrors: !1,
  objectMode: !0
}, lf = df;
function df(e, r, t) {
  Array.isArray(e) || (e = sf.call(arguments), r = null, t = null);
  var n = e[e.length - 1];
  typeof n == "function" && (t = e.splice(-1)[0], n = e[e.length - 1]), typeof n == "object" && typeof n.pipe != "function" && (r = e.splice(-1)[0]);
  var i = e[0], o = e[e.length - 1], f;
  if (r = ff({}, uf, r), !i)
    return t && j.nextTick(t), new Xn(r);
  if (i.writable && o.readable ? f = af(r, i, o) : e.length == 1 ? f = new of(r).wrap(e[0]) : i.writable ? f = i : o.readable ? f = o : f = new Xn(r), e.forEach(function(c, g) {
    var y = e[g + 1];
    y && c.pipe(y), c != f && c.on("error", f.emit.bind(f, "error"));
  }), t) {
    let c = function(g) {
      u || (u = !0, t(g));
    };
    var u = !1;
    f.on("error", c), o.on("finish", function() {
      c();
    }), o.on("close", function() {
      c();
    });
  }
  return f;
}
const cf = /* @__PURE__ */ Gt(lf);
var hf = function(r) {
  return function(t) {
    for (var n = new RegExp(r.key + "-([a-zA-Z0-9-_]+)", "gm"), i = {
      html: t,
      ids: [],
      css: ""
    }, o, f = {}; (o = n.exec(t)) !== null; )
      f[o[1]] === void 0 && (f[o[1]] = !0);
    return i.ids = Object.keys(r.inserted).filter(function(u) {
      if ((f[u] !== void 0 || r.registered[r.key + "-" + u] === void 0) && r.inserted[u] !== !0)
        return i.css += r.inserted[u], !0;
    }), i;
  };
}, pf = function(r) {
  return function(t) {
    for (var n = new RegExp(r.key + "-([a-zA-Z0-9-_]+)", "gm"), i = {
      html: t,
      styles: []
    }, o, f = {}; (o = n.exec(t)) !== null; )
      f[o[1]] === void 0 && (f[o[1]] = !0);
    var u = [], c = "";
    return Object.keys(r.inserted).forEach(function(g) {
      (f[g] !== void 0 || r.registered[r.key + "-" + g] === void 0) && r.inserted[g] !== !0 && (r.registered[r.key + "-" + g] ? (u.push(g), c += r.inserted[g]) : i.styles.push({
        key: r.key + "-global",
        ids: [g],
        css: r.inserted[g]
      }));
    }), i.styles.push({
      key: r.key,
      ids: u,
      css: c
    }), i;
  };
};
function Wt(e, r, t, n) {
  return '<style data-emotion="' + e + " " + r + '"' + n + ">" + t + "</style>";
}
var gf = function(r, t) {
  return function(n) {
    var i = r.inserted, o = r.key, f = r.registered, u = new RegExp("<|" + o + "-([a-zA-Z0-9-_]+)", "gm"), c = {}, g = "", y = "", p = "";
    for (var R in i)
      if (i.hasOwnProperty(R)) {
        var N = i[R], D = o + "-" + R;
        N !== !0 && f[D] === void 0 && (p += N, y += " " + R);
      }
    p !== "" && (g = Wt(o, y.substring(1), p, t));
    for (var x = "", A = "", b = 0, m; (m = u.exec(n)) !== null; ) {
      if (m[0] === "<") {
        x !== "" && (g += Wt(o, x.substring(1), A, t), x = "", A = ""), g += n.substring(b, m.index), b = m.index;
        continue;
      }
      var O = m[1], _ = i[O];
      _ === !0 || _ === void 0 || c[O] || (c[O] = !0, A += _, x += " " + O);
    }
    return g += n.substring(b), g;
  };
}, bf = function(r, t) {
  return function() {
    var n = {}, i = Go(), o = so(function(u) {
      var c = u[0], g = u[1];
      if (c === "open") {
        for (var y = "", p = {}, R, N = g.toString(), D = new RegExp(r.key + "-([a-zA-Z0-9-_]+)", "gm"); (R = D.exec(N)) !== null; )
          R !== null && n[R[1]] === void 0 && (p[R[1]] = !0);
        Object.keys(r.inserted).forEach(function(x) {
          r.inserted[x] !== !0 && n[x] === void 0 && (p[x] === !0 || r.registered[r.key + "-" + x] === void 0 && (p[x] = !0)) && (n[x] = !0, y += r.inserted[x]);
        }), y !== "" && this.queue('<style data-emotion="' + r.key + " " + Object.keys(p).join(" ") + '"' + t + ">" + y + "</style>");
      }
      this.queue(g);
    }, function() {
      this.queue(null);
    });
    return cf(i, o);
  };
}, vf = function(r, t) {
  return function(n) {
    var i = "";
    return n.styles.forEach(function(o) {
      i += Wt(o.key, o.ids.join(" "), o.css, t);
    }), i;
  };
};
function yf(e) {
  e.compat !== !0 && (e.compat = !0);
  var r = e.nonce !== void 0 ? ' nonce="' + e.nonce + '"' : "";
  return {
    extractCritical: hf(e),
    extractCriticalToChunks: pf(e),
    renderStylesToString: gf(e, r),
    renderStylesToNodeStream: bf(e, r),
    constructStyleTagsFromChunks: vf(e, r)
  };
}
var xe = Ga({ key: "leafygreen-ui", prepend: !0 }), mf = xe.flush, wf = xe.hydrate, _f = xe.cx, Sf = xe.merge, Ef = xe.getRegisteredStyles, Rf = xe.injectGlobal, xf = xe.keyframes, Tf = xe.css, kf = xe.sheet, zi = xe.cache, sn = yf(zi), Mf = sn.extractCritical, Cf = sn.renderStylesToString, Df = sn.renderStylesToNodeStream;
const Of = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  cache: zi,
  css: Tf,
  cx: _f,
  default: xe,
  extractCritical: Mf,
  flush: mf,
  getRegisteredStyles: Ef,
  hydrate: wf,
  injectGlobal: Rf,
  keyframes: xf,
  merge: Sf,
  renderStylesToNodeStream: Df,
  renderStylesToString: Cf,
  sheet: kf
}, Symbol.toStringTag, { value: "Module" }));
var X = { white: "#FFFFFF", black: "#001E2B", gray: { dark4: "#112733", dark3: "#1C2D38", dark2: "#3D4F58", dark1: "#5C6C75", base: "#889397", light1: "#C1C7C6", light2: "#E8EDEB", light3: "#F9FBFA" }, green: { dark3: "#023430", dark2: "#00684A", dark1: "#00A35C", base: "#00ED64", light1: "#71F6BA", light2: "#C0FAE6", light3: "#E3FCF7" }, purple: { dark3: "#2D0B59", dark2: "#5E0C9E", base: "#B45AF2", light2: "#F1D4FD", light3: "#F9EBFF" }, blue: { dark3: "#0C2657", dark2: "#083C90", dark1: "#1254B7", base: "#016BF8", light1: "#0498EC", light2: "#C3E7FE", light3: "#E1F7FF" }, yellow: { dark3: "#4C2100", dark2: "#944F01", base: "#FFC010", light2: "#FFEC9E", light3: "#FEF7DB" }, red: { dark3: "#5B0000", dark2: "#970606", base: "#DB3030", light1: "#FF6960", light2: "#FFCDC7", light3: "#FFEAE5" } };
function ge() {
  return ge = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, ge.apply(this, arguments);
}
function Af(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function kr(e, r) {
  return kr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, kr(e, r);
}
function Lf(e, r) {
  e.prototype = Object.create(r.prototype), e.prototype.constructor = e, kr(e, r);
}
function Ht(e) {
  return Ht = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Ht(e);
}
function Pf(e) {
  try {
    return Function.toString.call(e).indexOf("[native code]") !== -1;
  } catch {
    return typeof e == "function";
  }
}
function Gi() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Gi = function() {
    return !!e;
  })();
}
function Nf(e, r, t) {
  if (Gi())
    return Reflect.construct.apply(null, arguments);
  var n = [null];
  n.push.apply(n, r);
  var i = new (e.bind.apply(e, n))();
  return t && kr(i, t.prototype), i;
}
function $t(e) {
  var r = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return $t = function(n) {
    if (n === null || !Pf(n))
      return n;
    if (typeof n != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof r < "u") {
      if (r.has(n))
        return r.get(n);
      r.set(n, i);
    }
    function i() {
      return Nf(n, arguments, Ht(this).constructor);
    }
    return i.prototype = Object.create(n.prototype, {
      constructor: {
        value: i,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), kr(i, n);
  }, $t(e);
}
var Ff = {
  1: `Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).

`,
  2: `Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).

`,
  3: `Passed an incorrect argument to a color function, please pass a string representation of a color.

`,
  4: `Couldn't generate valid rgb string from %s, it returned %s.

`,
  5: `Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.

`,
  6: `Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).

`,
  7: `Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).

`,
  8: `Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.

`,
  9: `Please provide a number of steps to the modularScale helper.

`,
  10: `Please pass a number or one of the predefined scales to the modularScale helper as the ratio.

`,
  11: `Invalid value passed as base to modularScale, expected number or em string but got "%s"

`,
  12: `Expected a string ending in "px" or a number passed as the first argument to %s(), got "%s" instead.

`,
  13: `Expected a string ending in "px" or a number passed as the second argument to %s(), got "%s" instead.

`,
  14: `Passed invalid pixel value ("%s") to %s(), please pass a value like "12px" or 12.

`,
  15: `Passed invalid base value ("%s") to %s(), please pass a value like "12px" or 12.

`,
  16: `You must provide a template to this method.

`,
  17: `You passed an unsupported selector state to this method.

`,
  18: `minScreen and maxScreen must be provided as stringified numbers with the same units.

`,
  19: `fromSize and toSize must be provided as stringified numbers with the same units.

`,
  20: `expects either an array of objects or a single object with the properties prop, fromSize, and toSize.

`,
  21: "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  22: "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  23: `fontFace expects a name of a font-family.

`,
  24: `fontFace expects either the path to the font file(s) or a name of a local copy.

`,
  25: `fontFace expects localFonts to be an array.

`,
  26: `fontFace expects fileFormats to be an array.

`,
  27: `radialGradient requries at least 2 color-stops to properly render.

`,
  28: `Please supply a filename to retinaImage() as the first argument.

`,
  29: `Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.

`,
  30: "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  31: `The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation

`,
  32: `To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])
To pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')

`,
  33: `The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation

`,
  34: `borderRadius expects a radius value as a string or number as the second argument.

`,
  35: `borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.

`,
  36: `Property must be a string value.

`,
  37: `Syntax Error at %s.

`,
  38: `Formula contains a function that needs parentheses at %s.

`,
  39: `Formula is missing closing parenthesis at %s.

`,
  40: `Formula has too many closing parentheses at %s.

`,
  41: `All values in a formula must have the same unit or be unitless.

`,
  42: `Please provide a number of steps to the modularScale helper.

`,
  43: `Please pass a number or one of the predefined scales to the modularScale helper as the ratio.

`,
  44: `Invalid value passed as base to modularScale, expected number or em/rem string but got %s.

`,
  45: `Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.

`,
  46: `Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.

`,
  47: `minScreen and maxScreen must be provided as stringified numbers with the same units.

`,
  48: `fromSize and toSize must be provided as stringified numbers with the same units.

`,
  49: `Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.

`,
  50: `Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.

`,
  51: `Expects the first argument object to have the properties prop, fromSize, and toSize.

`,
  52: `fontFace expects either the path to the font file(s) or a name of a local copy.

`,
  53: `fontFace expects localFonts to be an array.

`,
  54: `fontFace expects fileFormats to be an array.

`,
  55: `fontFace expects a name of a font-family.

`,
  56: `linearGradient requries at least 2 color-stops to properly render.

`,
  57: `radialGradient requries at least 2 color-stops to properly render.

`,
  58: `Please supply a filename to retinaImage() as the first argument.

`,
  59: `Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.

`,
  60: "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  61: `Property must be a string value.

`,
  62: `borderRadius expects a radius value as a string or number as the second argument.

`,
  63: `borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.

`,
  64: `The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.

`,
  65: `To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').

`,
  66: `The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.

`,
  67: `You must provide a template to this method.

`,
  68: `You passed an unsupported selector state to this method.

`,
  69: `Expected a string ending in "px" or a number passed as the first argument to %s(), got %s instead.

`,
  70: `Expected a string ending in "px" or a number passed as the second argument to %s(), got %s instead.

`,
  71: `Passed invalid pixel value %s to %s(), please pass a value like "12px" or 12.

`,
  72: `Passed invalid base value %s to %s(), please pass a value like "12px" or 12.

`,
  73: `Please provide a valid CSS variable.

`,
  74: `CSS variable not found and no default was provided.

`,
  75: `important requires a valid style object, got a %s instead.

`,
  76: `fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.

`,
  77: `remToPx expects a value in "rem" but you provided it in "%s".

`,
  78: `base must be set in "px" or "%" but you set it in "%s".
`
};
function jf() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  var n = r[0], i = [], o;
  for (o = 1; o < r.length; o += 1)
    i.push(r[o]);
  return i.forEach(function(f) {
    n = n.replace(/%[a-z]/, f);
  }), n;
}
var De = /* @__PURE__ */ function(e) {
  Lf(r, e);
  function r(t) {
    var n;
    if (j.env.NODE_ENV === "production")
      n = e.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + t + " for more information.") || this;
    else {
      for (var i = arguments.length, o = new Array(i > 1 ? i - 1 : 0), f = 1; f < i; f++)
        o[f - 1] = arguments[f];
      n = e.call(this, jf.apply(void 0, [Ff[t]].concat(o))) || this;
    }
    return Af(n);
  }
  return r;
}(/* @__PURE__ */ $t(Error));
function kt(e) {
  return Math.round(e * 255);
}
function If(e, r, t) {
  return kt(e) + "," + kt(r) + "," + kt(t);
}
function Mr(e, r, t, n) {
  if (n === void 0 && (n = If), r === 0)
    return n(t, t, t);
  var i = (e % 360 + 360) % 360 / 60, o = (1 - Math.abs(2 * t - 1)) * r, f = o * (1 - Math.abs(i % 2 - 1)), u = 0, c = 0, g = 0;
  i >= 0 && i < 1 ? (u = o, c = f) : i >= 1 && i < 2 ? (u = f, c = o) : i >= 2 && i < 3 ? (c = o, g = f) : i >= 3 && i < 4 ? (c = f, g = o) : i >= 4 && i < 5 ? (u = f, g = o) : i >= 5 && i < 6 && (u = o, g = f);
  var y = t - o / 2, p = u + y, R = c + y, N = g + y;
  return n(p, R, N);
}
var Zn = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "00ffff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "0000ff",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "00ffff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "ff00ff",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "639",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
};
function Bf(e) {
  if (typeof e != "string")
    return e;
  var r = e.toLowerCase();
  return Zn[r] ? "#" + Zn[r] : e;
}
var qf = /^#[a-fA-F0-9]{6}$/, Wf = /^#[a-fA-F0-9]{8}$/, Hf = /^#[a-fA-F0-9]{3}$/, $f = /^#[a-fA-F0-9]{4}$/, Mt = /^rgb\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*\)$/i, Uf = /^rgb(?:a)?\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i, zf = /^hsl\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i, Gf = /^hsl(?:a)?\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
function cr(e) {
  if (typeof e != "string")
    throw new De(3);
  var r = Bf(e);
  if (r.match(qf))
    return {
      red: parseInt("" + r[1] + r[2], 16),
      green: parseInt("" + r[3] + r[4], 16),
      blue: parseInt("" + r[5] + r[6], 16)
    };
  if (r.match(Wf)) {
    var t = parseFloat((parseInt("" + r[7] + r[8], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + r[1] + r[2], 16),
      green: parseInt("" + r[3] + r[4], 16),
      blue: parseInt("" + r[5] + r[6], 16),
      alpha: t
    };
  }
  if (r.match(Hf))
    return {
      red: parseInt("" + r[1] + r[1], 16),
      green: parseInt("" + r[2] + r[2], 16),
      blue: parseInt("" + r[3] + r[3], 16)
    };
  if (r.match($f)) {
    var n = parseFloat((parseInt("" + r[4] + r[4], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + r[1] + r[1], 16),
      green: parseInt("" + r[2] + r[2], 16),
      blue: parseInt("" + r[3] + r[3], 16),
      alpha: n
    };
  }
  var i = Mt.exec(r);
  if (i)
    return {
      red: parseInt("" + i[1], 10),
      green: parseInt("" + i[2], 10),
      blue: parseInt("" + i[3], 10)
    };
  var o = Uf.exec(r.substring(0, 50));
  if (o)
    return {
      red: parseInt("" + o[1], 10),
      green: parseInt("" + o[2], 10),
      blue: parseInt("" + o[3], 10),
      alpha: parseFloat("" + o[4]) > 1 ? parseFloat("" + o[4]) / 100 : parseFloat("" + o[4])
    };
  var f = zf.exec(r);
  if (f) {
    var u = parseInt("" + f[1], 10), c = parseInt("" + f[2], 10) / 100, g = parseInt("" + f[3], 10) / 100, y = "rgb(" + Mr(u, c, g) + ")", p = Mt.exec(y);
    if (!p)
      throw new De(4, r, y);
    return {
      red: parseInt("" + p[1], 10),
      green: parseInt("" + p[2], 10),
      blue: parseInt("" + p[3], 10)
    };
  }
  var R = Gf.exec(r.substring(0, 50));
  if (R) {
    var N = parseInt("" + R[1], 10), D = parseInt("" + R[2], 10) / 100, x = parseInt("" + R[3], 10) / 100, A = "rgb(" + Mr(N, D, x) + ")", b = Mt.exec(A);
    if (!b)
      throw new De(4, r, A);
    return {
      red: parseInt("" + b[1], 10),
      green: parseInt("" + b[2], 10),
      blue: parseInt("" + b[3], 10),
      alpha: parseFloat("" + R[4]) > 1 ? parseFloat("" + R[4]) / 100 : parseFloat("" + R[4])
    };
  }
  throw new De(5);
}
function Vf(e) {
  var r = e.red / 255, t = e.green / 255, n = e.blue / 255, i = Math.max(r, t, n), o = Math.min(r, t, n), f = (i + o) / 2;
  if (i === o)
    return e.alpha !== void 0 ? {
      hue: 0,
      saturation: 0,
      lightness: f,
      alpha: e.alpha
    } : {
      hue: 0,
      saturation: 0,
      lightness: f
    };
  var u, c = i - o, g = f > 0.5 ? c / (2 - i - o) : c / (i + o);
  switch (i) {
    case r:
      u = (t - n) / c + (t < n ? 6 : 0);
      break;
    case t:
      u = (n - r) / c + 2;
      break;
    default:
      u = (r - t) / c + 4;
      break;
  }
  return u *= 60, e.alpha !== void 0 ? {
    hue: u,
    saturation: g,
    lightness: f,
    alpha: e.alpha
  } : {
    hue: u,
    saturation: g,
    lightness: f
  };
}
function $e(e) {
  return Vf(cr(e));
}
var Yf = function(r) {
  return r.length === 7 && r[1] === r[2] && r[3] === r[4] && r[5] === r[6] ? "#" + r[1] + r[3] + r[5] : r;
}, Ut = Yf;
function Ye(e) {
  var r = e.toString(16);
  return r.length === 1 ? "0" + r : r;
}
function Ct(e) {
  return Ye(Math.round(e * 255));
}
function Kf(e, r, t) {
  return Ut("#" + Ct(e) + Ct(r) + Ct(t));
}
function Ur(e, r, t) {
  return Mr(e, r, t, Kf);
}
function Xf(e, r, t) {
  if (typeof e == "number" && typeof r == "number" && typeof t == "number")
    return Ur(e, r, t);
  if (typeof e == "object" && r === void 0 && t === void 0)
    return Ur(e.hue, e.saturation, e.lightness);
  throw new De(1);
}
function Zf(e, r, t, n) {
  if (typeof e == "number" && typeof r == "number" && typeof t == "number" && typeof n == "number")
    return n >= 1 ? Ur(e, r, t) : "rgba(" + Mr(e, r, t) + "," + n + ")";
  if (typeof e == "object" && r === void 0 && t === void 0 && n === void 0)
    return e.alpha >= 1 ? Ur(e.hue, e.saturation, e.lightness) : "rgba(" + Mr(e.hue, e.saturation, e.lightness) + "," + e.alpha + ")";
  throw new De(2);
}
function zt(e, r, t) {
  if (typeof e == "number" && typeof r == "number" && typeof t == "number")
    return Ut("#" + Ye(e) + Ye(r) + Ye(t));
  if (typeof e == "object" && r === void 0 && t === void 0)
    return Ut("#" + Ye(e.red) + Ye(e.green) + Ye(e.blue));
  throw new De(6);
}
function tt(e, r, t, n) {
  if (typeof e == "string" && typeof r == "number") {
    var i = cr(e);
    return "rgba(" + i.red + "," + i.green + "," + i.blue + "," + r + ")";
  } else {
    if (typeof e == "number" && typeof r == "number" && typeof t == "number" && typeof n == "number")
      return n >= 1 ? zt(e, r, t) : "rgba(" + e + "," + r + "," + t + "," + n + ")";
    if (typeof e == "object" && r === void 0 && t === void 0 && n === void 0)
      return e.alpha >= 1 ? zt(e.red, e.green, e.blue) : "rgba(" + e.red + "," + e.green + "," + e.blue + "," + e.alpha + ")";
  }
  throw new De(7);
}
var Jf = function(r) {
  return typeof r.red == "number" && typeof r.green == "number" && typeof r.blue == "number" && (typeof r.alpha != "number" || typeof r.alpha > "u");
}, Qf = function(r) {
  return typeof r.red == "number" && typeof r.green == "number" && typeof r.blue == "number" && typeof r.alpha == "number";
}, es = function(r) {
  return typeof r.hue == "number" && typeof r.saturation == "number" && typeof r.lightness == "number" && (typeof r.alpha != "number" || typeof r.alpha > "u");
}, rs = function(r) {
  return typeof r.hue == "number" && typeof r.saturation == "number" && typeof r.lightness == "number" && typeof r.alpha == "number";
};
function Ue(e) {
  if (typeof e != "object")
    throw new De(8);
  if (Qf(e))
    return tt(e);
  if (Jf(e))
    return zt(e);
  if (rs(e))
    return Zf(e);
  if (es(e))
    return Xf(e);
  throw new De(8);
}
function Vi(e, r, t) {
  return function() {
    var i = t.concat(Array.prototype.slice.call(arguments));
    return i.length >= r ? e.apply(this, i) : Vi(e, r, i);
  };
}
function ve(e) {
  return Vi(e, e.length, []);
}
function ts(e, r) {
  if (r === "transparent")
    return r;
  var t = $e(r);
  return Ue(ge({}, t, {
    hue: t.hue + parseFloat(e)
  }));
}
ve(ts);
function br(e, r, t) {
  return Math.max(e, Math.min(r, t));
}
function ns(e, r) {
  if (r === "transparent")
    return r;
  var t = $e(r);
  return Ue(ge({}, t, {
    lightness: br(0, 1, t.lightness - parseFloat(e))
  }));
}
ve(ns);
function is(e, r) {
  if (r === "transparent")
    return r;
  var t = $e(r);
  return Ue(ge({}, t, {
    saturation: br(0, 1, t.saturation - parseFloat(e))
  }));
}
ve(is);
function as(e, r) {
  if (r === "transparent")
    return r;
  var t = $e(r);
  return Ue(ge({}, t, {
    lightness: br(0, 1, t.lightness + parseFloat(e))
  }));
}
ve(as);
function os(e, r, t) {
  if (r === "transparent")
    return t;
  if (t === "transparent")
    return r;
  if (e === 0)
    return t;
  var n = cr(r), i = ge({}, n, {
    alpha: typeof n.alpha == "number" ? n.alpha : 1
  }), o = cr(t), f = ge({}, o, {
    alpha: typeof o.alpha == "number" ? o.alpha : 1
  }), u = i.alpha - f.alpha, c = parseFloat(e) * 2 - 1, g = c * u === -1 ? c : c + u, y = 1 + c * u, p = (g / y + 1) / 2, R = 1 - p, N = {
    red: Math.floor(i.red * p + f.red * R),
    green: Math.floor(i.green * p + f.green * R),
    blue: Math.floor(i.blue * p + f.blue * R),
    alpha: i.alpha * parseFloat(e) + f.alpha * (1 - parseFloat(e))
  };
  return tt(N);
}
var fs = ve(os), Yi = fs;
function ss(e, r) {
  if (r === "transparent")
    return r;
  var t = cr(r), n = typeof t.alpha == "number" ? t.alpha : 1, i = ge({}, t, {
    alpha: br(0, 1, (n * 100 + parseFloat(e) * 100) / 100)
  });
  return tt(i);
}
ve(ss);
function us(e, r) {
  if (r === "transparent")
    return r;
  var t = $e(r);
  return Ue(ge({}, t, {
    saturation: br(0, 1, t.saturation + parseFloat(e))
  }));
}
ve(us);
function ls(e, r) {
  return r === "transparent" ? r : Ue(ge({}, $e(r), {
    hue: parseFloat(e)
  }));
}
ve(ls);
function ds(e, r) {
  return r === "transparent" ? r : Ue(ge({}, $e(r), {
    lightness: parseFloat(e)
  }));
}
ve(ds);
function cs(e, r) {
  return r === "transparent" ? r : Ue(ge({}, $e(r), {
    saturation: parseFloat(e)
  }));
}
ve(cs);
function hs(e, r) {
  return r === "transparent" ? r : Yi(parseFloat(e), "rgb(0, 0, 0)", r);
}
ve(hs);
function ps(e, r) {
  return r === "transparent" ? r : Yi(parseFloat(e), "rgb(255, 255, 255)", r);
}
ve(ps);
function gs(e, r) {
  if (r === "transparent")
    return r;
  var t = cr(r), n = typeof t.alpha == "number" ? t.alpha : 1, i = ge({}, t, {
    alpha: br(0, 1, +(n * 100 - parseFloat(e) * 100).toFixed(2) / 100)
  });
  return tt(i);
}
var bs = ve(gs), Ki = bs, Ts = { Mobile: 320, Tablet: 768, Desktop: 1024, XLDesktop: 1440 };
function vs(e) {
  var r = function(t, n) {
    if (typeof t != "object" || !t)
      return t;
    var i = t[Symbol.toPrimitive];
    if (i !== void 0) {
      var o = i.call(t, n);
      if (typeof o != "object")
        return o;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(t);
  }(e, "string");
  return typeof r == "symbol" ? r : r + "";
}
function h(e, r, t) {
  return (r = vs(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
var W = { Disabled: "disabled", Placeholder: "placeholder", Primary: "primary", Secondary: "secondary", InversePrimary: "inversePrimary", InverseSecondary: "inverseSecondary", Info: "info", Warning: "warning", Error: "error", Success: "success", Link: "link" }, v = { Default: "default", Hover: "hover", Focus: "focus" }, wr = X.black, re = X.blue, G = X.gray, qe = X.green, Se = X.red, ys = X.white, er = X.yellow, ms = { background: h(h(h(h(h(h(h(h({}, W.Primary, h(h(h({}, v.Default, wr), v.Hover, G.dark2), v.Focus, re.dark3)), W.Secondary, h(h(h({}, v.Default, G.dark4), v.Hover, G.dark2), v.Focus, re.dark3)), W.InversePrimary, h(h(h({}, v.Default, G.light2), v.Hover, G.light3), v.Focus, re.light2)), W.Info, h(h(h({}, v.Default, re.dark3), v.Hover, re.dark3), v.Focus, re.dark3)), W.Warning, h(h(h({}, v.Default, er.dark3), v.Hover, er.dark3), v.Focus, er.dark3)), W.Success, h(h(h({}, v.Default, qe.dark3), v.Hover, qe.dark3), v.Focus, qe.dark3)), W.Error, h(h(h({}, v.Default, Se.dark3), v.Hover, Se.dark3), v.Focus, Se.dark3)), W.Disabled, h(h(h({}, v.Default, G.dark3), v.Hover, G.dark3), v.Focus, G.dark3)), border: h(h(h(h(h({}, W.Primary, h(h(h({}, v.Default, G.base), v.Hover, G.base), v.Focus, re.light1)), W.Secondary, h(h(h({}, v.Default, G.dark2), v.Hover, G.dark2), v.Focus, re.light1)), W.Success, h(h(h({}, v.Default, qe.dark1), v.Hover, qe.dark1), v.Focus, re.light1)), W.Error, h(h(h({}, v.Default, Se.light1), v.Hover, Se.light1), v.Focus, re.light1)), W.Disabled, h(h(h({}, v.Default, G.dark2), v.Hover, G.dark2), v.Focus, G.dark2)), icon: h(h(h(h(h(h(h(h({}, W.Primary, h(h(h({}, v.Default, G.light1), v.Hover, G.light3), v.Focus, re.light3)), W.Secondary, h(h(h({}, v.Default, G.base), v.Hover, G.light3), v.Focus, re.light3)), W.InversePrimary, h(h(h({}, v.Default, ys), v.Hover, wr), v.Focus, re.dark2)), W.Info, h(h(h({}, v.Default, re.light1), v.Hover, re.light1), v.Focus, re.light1)), W.Warning, h(h(h({}, v.Default, er.base), v.Hover, er.base), v.Focus, er.base)), W.Success, h(h(h({}, v.Default, qe.base), v.Hover, qe.base), v.Focus, qe.base)), W.Error, h(h(h({}, v.Default, Se.light1), v.Hover, Se.light1), v.Focus, Se.light1)), W.Disabled, h(h(h({}, v.Default, G.dark1), v.Hover, G.dark1), v.Focus, G.dark1)), text: h(h(h(h(h(h(h(h({}, W.Primary, h(h(h({}, v.Default, G.light2), v.Hover, G.light2), v.Focus, re.light3)), W.Placeholder, h(h(h({}, v.Default, G.dark1), v.Hover, G.dark1), v.Focus, G.dark1)), W.Secondary, h(h(h({}, v.Default, G.light1), v.Hover, G.light2), v.Focus, re.light3)), W.InversePrimary, h(h(h({}, v.Default, wr), v.Hover, wr), v.Focus, re.dark2)), W.InverseSecondary, h(h(h({}, v.Default, G.dark2), v.Hover, wr), v.Focus, re.dark2)), W.Error, h(h(h({}, v.Default, Se.light1), v.Hover, Se.light1), v.Focus, Se.light1)), W.Disabled, h(h(h({}, v.Default, G.dark1), v.Hover, G.dark1), v.Focus, G.dark1)), W.Link, h(h(h({}, v.Default, re.light1), v.Hover, re.light1), v.Focus, re.light1)) }, rr = X.black, te = X.blue, J = X.gray, We = X.green, Ee = X.red, tr = X.white, nr = X.yellow, ws = { background: h(h(h(h(h(h(h(h({}, W.Primary, h(h(h({}, v.Default, tr), v.Hover, J.light2), v.Focus, te.light3)), W.Secondary, h(h(h({}, v.Default, J.light3), v.Hover, J.light2), v.Focus, te.light3)), W.InversePrimary, h(h(h({}, v.Default, rr), v.Hover, J.dark3), v.Focus, te.dark2)), W.Info, h(h(h({}, v.Default, te.light3), v.Hover, te.light3), v.Focus, te.light3)), W.Warning, h(h(h({}, v.Default, nr.light3), v.Hover, nr.light3), v.Focus, nr.light3)), W.Success, h(h(h({}, v.Default, We.light3), v.Hover, We.light3), v.Focus, We.light3)), W.Error, h(h(h({}, v.Default, Ee.light3), v.Hover, Ee.light3), v.Focus, Ee.light3)), W.Disabled, h(h(h({}, v.Default, J.light2), v.Hover, J.light2), v.Focus, J.light2)), border: h(h(h(h(h({}, W.Primary, h(h(h({}, v.Default, J.base), v.Hover, J.base), v.Focus, te.light1)), W.Secondary, h(h(h({}, v.Default, J.light2), v.Hover, J.light2), v.Focus, te.light1)), W.Success, h(h(h({}, v.Default, We.dark1), v.Hover, We.dark1), v.Focus, te.light1)), W.Error, h(h(h({}, v.Default, Ee.base), v.Hover, Ee.base), v.Focus, te.light1)), W.Disabled, h(h(h({}, v.Default, J.light1), v.Hover, J.light1), v.Focus, J.light1)), icon: h(h(h(h(h(h(h(h({}, W.Primary, h(h(h({}, v.Default, J.dark1), v.Hover, rr), v.Focus, te.dark1)), W.Secondary, h(h(h({}, v.Default, J.base), v.Hover, rr), v.Focus, te.dark1)), W.InversePrimary, h(h(h({}, v.Default, tr), v.Hover, tr), v.Focus, te.light2)), W.Info, h(h(h({}, v.Default, te.base), v.Hover, te.base), v.Focus, te.base)), W.Warning, h(h(h({}, v.Default, nr.dark2), v.Hover, nr.dark2), v.Focus, nr.dark2)), W.Success, h(h(h({}, v.Default, We.dark1), v.Hover, We.dark1), v.Focus, We.dark1)), W.Error, h(h(h({}, v.Default, Ee.base), v.Hover, Ee.base), v.Focus, Ee.base)), W.Disabled, h(h(h({}, v.Default, J.base), v.Hover, J.base), v.Focus, J.base)), text: h(h(h(h(h(h(h(h({}, W.Primary, h(h(h({}, v.Default, rr), v.Hover, rr), v.Focus, te.dark1)), W.Secondary, h(h(h({}, v.Default, J.dark1), v.Hover, rr), v.Focus, te.dark1)), W.InversePrimary, h(h(h({}, v.Default, tr), v.Hover, tr), v.Focus, te.light2)), W.InverseSecondary, h(h(h({}, v.Default, J.light1), v.Hover, tr), v.Focus, te.light2)), W.Error, h(h(h({}, v.Default, Ee.base), v.Hover, Ee.base), v.Focus, Ee.base)), W.Disabled, h(h(h({}, v.Default, J.base), v.Hover, J.base), v.Focus, J.base)), W.Placeholder, h(h(h({}, v.Default, J.base), v.Hover, J.base), v.Focus, J.base)), W.Link, h(h(h({}, v.Default, te.base), v.Hover, te.base), v.Focus, te.base)) }, ks = h(h({}, Br.Dark, ms), Br.Light, ws), zr = { Dark: "dark", Light: "light" }, Ms = h(h({}, zr.Light, { default: "0 0 0 2px ".concat(X.white, ", 0 0 0 4px ").concat(X.blue.light1), input: "0 0 0 3px ".concat(X.blue.light1) }), zr.Dark, { default: "0 0 0 2px ".concat(X.black, ", 0 0 0 4px ").concat(X.blue.light1), input: "0 0 0 3px ".concat(X.blue.light1) }), Cs = { default: "'Euclid Circular A', 'Helvetica Neue', Helvetica, Arial, sans-serif", serif: "'MongoDB Value Serif', 'Times New Roman', serif", code: "'Source Code Pro', Menlo, monospace" }, Ds = { regular: 400, medium: 500, bold: 700 }, Os = h(h({}, zr.Light, { gray: "0 0 0 3px ".concat(X.gray.light2), green: "0 0 0 3px ".concat(X.green.light2), red: "0 0 0 3px ".concat(X.red.light2) }), zr.Dark, { gray: "0 0 0 3px ".concat(X.gray.dark2), green: "0 0 0 3px ".concat(X.green.dark3), red: "0 0 0 3px ".concat(X.yellow.dark3) }), _s = Ki(0.75, X.black), Ss = Ki(0.85, X.white);
h(h({}, Br.Light, { 100: "0px 2px 4px 1px ".concat(_s) }), Br.Dark, { 100: "0px 4px 20px -4px ".concat(Ss) });
var As = { XSmall: "xsmall", Small: "small", Default: "default", Large: "large" }, Ls = { 0: 0, 25: 1, 50: 2, 100: 4, 150: 6, 200: 8, 300: 12, 400: 16, 500: 20, 600: 24, 800: 32, 900: 36, 1e3: 40, 1200: 48, 1400: 56, 1600: 64, 1800: 72, 1: 4, 2: 8, 3: 16, 4: 24, 5: 32, 6: 64, 7: 88 }, Ps = { faster: 100, default: 150, slower: 300, slowest: 500 }, Jn = { Body1: 13, Body2: 16 }, Ns = { body1: { fontSize: Jn.Body1, lineHeight: 20 }, body2: { fontSize: Jn.Body2, lineHeight: 28 }, code1: { fontSize: 13, lineHeight: 20 }, code2: { fontSize: 15, lineHeight: 24 }, disclaimer: { fontSize: 12, lineHeight: 20 }, large: { fontSize: 18, lineHeight: 24 } };
const Fs = /* @__PURE__ */ Zi(Of);
export {
  Ps as A,
  Os as B,
  Jn as C,
  Cs as E,
  X as F,
  Ds as L,
  Ls as M,
  Ns as N,
  ks as P,
  Lf as _,
  ge as a,
  Yi as b,
  Ki as c,
  Ga as d,
  As as j,
  xf as l,
  Tf as m,
  Rf as n,
  _f as o,
  Fs as r,
  Ts as t,
  Ms as w
};
